// AUTO-GENERATED from /tmp/shein_products.json — DO NOT edit manually.
// Source: 5 SHEIN catalog ZIPs supplied by the customer.

export const SHEIN_DISCOUNT_PERCENT = 30;

export const SHEIN_SUBCATEGORIES = [
  { id: "women", label: { en: "Women", ar: "نسائي", fr: "Femme" } },
  { id: "men", label: { en: "Men", ar: "رجالي", fr: "Homme" } },
  { id: "kids", label: { en: "Kids", ar: "أطفال", fr: "Enfants" } },
  { id: "shoes", label: { en: "Shoes", ar: "أحذية", fr: "Chaussures" } },
  { id: "accessories", label: { en: "Bags & Accessories", ar: "حقائب وإكسسوارات", fr: "Sacs et accessoires" } },
  { id: "beauty", label: { en: "Beauty / Cosmetics", ar: "مستحضرات تجميل", fr: "Beauté / Cosmétiques" } },
  { id: "phone_accessories", label: { en: "Phone Accessories", ar: "اكسسوارات الهاتف", fr: "Accessoires téléphone" } },
  { id: "others", label: { en: "Others", ar: "غير ذلك", fr: "Autres" } },
];

// Base path under /public for SHEIN product images.
const SHEIN_BASE = "/products/shein";

const img = (folder, fn) => `${SHEIN_BASE}/${folder}/${encodeURIComponent(fn)}`;

export const SHEIN_PRODUCTS = [
  {
    id: "103",
    name: { en: "Black Mini Bow Crossbody Bag", ar: "Black Mini Bow Crossbody Bag", fr: "Black Mini Bow Crossbody Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "black", ar: "أسود", fr: "Noir" },
    quantity: 1,
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "103.png"), img("1", "103.2.png"), img("1", "103.3.png")],
  },
  {
    id: "104",
    name: { en: "Crochet Triangle Bikini Set", ar: "Crochet Triangle Bikini Set", fr: "Crochet Triangle Bikini Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    sizes: [{ label: "xs", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "104.png"), img("1", "104.2.png"), img("1", "104.3.png")],
  },
  {
    id: "105",
    name: { en: "Kids Brown Sport Sneakers with Velcro Strap", ar: "Kids Brown Sport Sneakers with Velcro Strap", fr: "Kids Brown Sport Sneakers with Velcro Strap" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "brown", ar: "بني", fr: "Marron" },
    sizes: [{ label: "EU 30", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "105.png"), img("1", "105.2.png"), img("1", "105.3.png")],
  },
  {
    id: "106",
    name: { en: "Leopard Print Underwire Bikini Set", ar: "Leopard Print Underwire Bikini Set", fr: "Leopard Print Underwire Bikini Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Leopard", ar: "نمري", fr: "Léopard" },
      { en: "Brown Black", ar: "بني أسود", fr: "Marron Noir" },
    ],
    sizes: [{ label: "s", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "106.png"), img("1", "106.2.png"), img("1", "106.3.png")],
  },
  {
    id: "107",
    name: { en: "Cojemimur Reed Diffuser – Classic Flora / 50ml", ar: "Cojemimur Reed Diffuser – Classic Flora / 50ml", fr: "Cojemimur Reed Diffuser – Classic Flora / 50ml" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 6.5,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "107.png"), img("1", "107.2.png"), img("1", "107.3.png")],
  },
  {
    id: "108",
    name: { en: "Black Fringed Shawl Scarf", ar: "Black Fringed Shawl Scarf", fr: "Black Fringed Shawl Scarf" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "black", ar: "أسود", fr: "Noir" },
    quantity: 1,
    originalPrice: 7.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "108.png"), img("1", "108.2.png"), img("1", "108.3.png")],
  },
  {
    id: "109",
    name: { en: "Black Drawstring Travel Shoe Bag", ar: "Black Drawstring Travel Shoe Bag", fr: "Black Drawstring Travel Shoe Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "black", ar: "أسود", fr: "Noir" },
    quantity: 1,
    originalPrice: 3.5,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "109.png"), img("1", "109.2.png")],
  },
  {
    id: "110",
    name: { en: "Baby Girl Black Bow Embroidered Romper", ar: "Baby Girl Black Bow Embroidered Romper", fr: "Baby Girl Black Bow Embroidered Romper" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Black with cream collar", ar: "أسود / with / كريمي / collar", fr: "Noir / With / Crème / Collar" },
    quantity: 1,
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "110.png"), img("1", "110.2.png"), img("1", "110.3.png")],
  },
  {
    id: "111",
    name: { en: "Girl Floral Blouse & Suspender Skirted Bloomer Set", ar: "Girl Floral Blouse & Suspender Skirted Bloomer Set", fr: "Girl Floral Blouse & Suspender Skirted Bloomer Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Light pink/khaki", ar: "فاتح / وردي / كاكي", fr: "Clair / Rose / Kaki" },
    quantity: 1,
    originalPrice: 20.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "111.png"), img("1", "111.2.png"), img("1", "111.3.png")],
  },
  {
    id: "112",
    name: { en: "Reusable Waterproof Wet Bag", ar: "Reusable Waterproof Wet Bag", fr: "Reusable Waterproof Wet Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Rust Brown", ar: "rust / بني", fr: "Rust / Marron" },
    quantity: 1,
    originalPrice: 4.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "112.png"), img("1", "112.2.png"), img("1", "112.3.png")],
  },
  {
    id: "113",
    name: { en: "Zebra Print Cami Layered Midi Dress", ar: "Zebra Print Cami Layered Midi Dress", fr: "Zebra Print Cami Layered Midi Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black & White Zebra Print", ar: "أسود / & / أبيض / zebra / print", fr: "Noir / & / Blanc / Zebra / Print" },
    sizes: [{ label: "s", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "113.png"), img("1", "113.2.png"), img("1", "113.3.png")],
  },
  {
    id: "114",
    name: { en: "Women’s Brown Halter Top & Shorts Set", ar: "Women’s Brown Halter Top & Shorts Set", fr: "Women’s Brown Halter Top & Shorts Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "brown", ar: "بني", fr: "Marron" },
      { en: "black", ar: "أسود", fr: "Noir" },
    ],
    sizes: [{ label: "xs", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "114.png"), img("1", "114.1.png"), img("1", "114.2.png"), img("1", "114.2.2.png"), img("1", "114.3.png"), img("1", "114.3.3.png")],
  },
  {
    id: "115",
    name: { en: "Women’s Black Faux Leather Wide-Leg Pants", ar: "Women’s Black Faux Leather Wide-Leg Pants", fr: "Women’s Black Faux Leather Wide-Leg Pants" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "xl", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "115.png"), img("1", "115.2.png"), img("1", "115.3.png")],
  },
  {
    id: "116",
    name: { en: "Women’s Crochet Halter Maxi Dress", ar: "Women’s Crochet Halter Maxi Dress", fr: "Women’s Crochet Halter Maxi Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "متعدد الألوان", fr: "Multicolore" },
    sizes: [{ label: "xs", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "116.png"), img("1", "116.2.png"), img("1", "116.3.png")],
  },
  {
    id: "117",
    name: { en: "Black Textured Underwire Bikini Set with Side Tie Bottom", ar: "Black Textured Underwire Bikini Set with Side Tie Bottom", fr: "Black Textured Underwire Bikini Set with Side Tie Bottom" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "xs", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "117.PNG"), img("1", "117.2.PNG"), img("1", "117.3.PNG")],
  },
  {
    id: "118",
    name: { en: "Leopard Print Bandeau Bikini Set", ar: "Leopard Print Bandeau Bikini Set", fr: "Leopard Print Bandeau Bikini Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Brown", ar: "بني", fr: "Marron" },
      { en: "Black Leopard Print", ar: "أسود نمري Print", fr: "Noir Léopard Print" },
    ],
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "118.png"), img("1", "118.2.png"), img("1", "118.3.png")],
  },
  {
    id: "119",
    name: { en: "Button Front Mini Skort", ar: "Button Front Mini Skort", fr: "Button Front Mini Skort" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "1 black", ar: "1 أسود", fr: "1 Noir" },
      { en: "1 brown", ar: "1 بني", fr: "1 Marron" },
    ],
    sizes: [{ label: "xl", qty: 2 }],
    originalPrice: 8.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "119.png"), img("1", "119.2.png"), img("1", "119.3.png"), img("1", "119.4.png"), img("1", "119.5.png"), img("1", "119.6.png")],
  },
  {
    id: "120",
    name: { en: "3-Piece Bow Print Lounge Set", ar: "3-Piece Bow Print Lounge Set", fr: "3-Piece Bow Print Lounge Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "muted pink", ar: "muted / وردي", fr: "Muted / Rose" },
    sizes: [{ label: "s", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "120.png"), img("1", "120.2.png"), img("1", "120.3.png")],
  },
  {
    id: "121",
    name: { en: "Kids Beige Teddy Bear Knit Sweater", ar: "Kids Beige Teddy Bear Knit Sweater", fr: "Kids Beige Teddy Bear Knit Sweater" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "light cream", ar: "فاتح / كريمي", fr: "Clair / Crème" },
    sizes: [{ label: "6 years", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "121.png"), img("1", "121.2.png"), img("1", "121.3.png")],
  },
  {
    id: "122",
    name: { en: "Baby Girl Blue Floral Puff Sleeve Romper with Matching Headband", ar: "Baby Girl Blue Floral Puff Sleeve Romper with Matching Headband", fr: "Baby Girl Blue Floral Puff Sleeve Romper with Matching Headband" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "White with light blue floral print", ar: "أبيض / with / فاتح / أزرق / floral / print", fr: "Blanc / With / Clair / Bleu / Floral / Print" },
    sizes: [{ label: "6-9 months", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "122.png"), img("1", "122.2.png"), img("1", "122.3.png")],
  },
  {
    id: "123",
    name: { en: "Kids Brown Denim Cargo Jogger Pants", ar: "Kids Brown Denim Cargo Jogger Pants", fr: "Kids Brown Denim Cargo Jogger Pants" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Washed brown", ar: "washed / بني", fr: "Washed / Marron" },
    sizes: [{ label: "6 years", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "123.png"), img("1", "123.2.png"), img("1", "123.3.png")],
  },
  {
    id: "124",
    name: { en: "Women’s White V-Neck Cap Sleeve T-Shirt", ar: "Women’s White V-Neck Cap Sleeve T-Shirt", fr: "Women’s White V-Neck Cap Sleeve T-Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "white", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "s", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "124.png"), img("1", "124.2.png"), img("1", "124.3.png")],
  },
  {
    id: "125",
    name: { en: "Women’s 2-Piece Halter Neck Summer Co-ord Set", ar: "Women’s 2-Piece Halter Neck Summer Co-ord Set", fr: "Women’s 2-Piece Halter Neck Summer Co-ord Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Burgundy", ar: "خمري", fr: "Bordeaux" },
    sizes: [{ label: "xs", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "125.png"), img("1", "125.2.png"), img("1", "125.3.png")],
  },
  {
    id: "126",
    name: { en: "Girls 3-Piece Pink Bow Hoodie Top & Denim Pants Set", ar: "Girls 3-Piece Pink Bow Hoodie Top & Denim Pants Set", fr: "Girls 3-Piece Pink Bow Hoodie Top & Denim Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Pink", ar: "وردي", fr: "Rose" },
      { en: "Light Blue Denim", ar: "فاتح أزرق Denim", fr: "Clair Bleu Denim" },
    ],
    sizes: [{ label: "2-3 years", qty: 1 }],
    originalPrice: 22.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "126.png"), img("1", "126.2.png"), img("1", "126.3.png")],
  },
  {
    id: "127",
    name: { en: "Men’s Grey Ribbed Sleeveless Polo", ar: "Men’s Grey Ribbed Sleeveless Polo", fr: "Men’s Grey Ribbed Sleeveless Polo" },
    category: "shein",
    sheinCategory: "men",
    authentic: false,
    discountPct: 30,
    color: { en: "grey", ar: "رمادي", fr: "Gris" },
    sizes: [{ label: "xl", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "127.png"), img("1", "127.2.png"), img("1", "127.3.png")],
  },
  {
    id: "128",
    name: { en: "Women’s Beige Striped Smocked Top & Shorts Set", ar: "Women’s Beige Striped Smocked Top & Shorts Set", fr: "Women’s Beige Striped Smocked Top & Shorts Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Beige", ar: "بيج", fr: "Beige" },
      { en: "Khaki Stripes", ar: "كاكي Stripes", fr: "Kaki Stripes" },
    ],
    sizes: [{ label: "xs", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "128.png"), img("1", "128.2.png"), img("1", "128.3.png")],
  },
  {
    id: "129",
    name: { en: "Girls Cream Teddy Embroidered Cropped Turtleneck Sweater", ar: "Girls Cream Teddy Embroidered Cropped Turtleneck Sweater", fr: "Girls Cream Teddy Embroidered Cropped Turtleneck Sweater" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Cream", ar: "كريمي", fr: "Crème" },
    sizes: [{ label: "12 years", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "129.png"), img("1", "129.2.png"), img("1", "129.3.png")],
  },
  {
    id: "130",
    name: { en: "Baby Girls Green Plaid Lace Trim Dress with Matching Bonnet", ar: "Baby Girls Green Plaid Lace Trim Dress with Matching Bonnet", fr: "Baby Girls Green Plaid Lace Trim Dress with Matching Bonnet" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Olive Green", ar: "زيتوني / أخضر", fr: "Olive / Vert" },
    sizes: [{ label: "6–9 months", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "130.png"), img("1", "130.2.png"), img("1", "130.3.png")],
  },
  {
    id: "131",
    name: { en: "Chunky Mesh Panel Sneakers", ar: "Chunky Mesh Panel Sneakers", fr: "Chunky Mesh Panel Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Light Grey", ar: "فاتح / رمادي", fr: "Clair / Gris" },
    sizes: [{ label: "39", qty: 1 }],
    originalPrice: 20.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "131.png"), img("1", "131.2.png"), img("1", "131.3.png")],
  },
  {
    id: "132",
    name: { en: "Women’s Strapless Ruffle Mini Dress", ar: "Women’s Strapless Ruffle Mini Dress", fr: "Women’s Strapless Ruffle Mini Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "بني", fr: "Marron" },
    sizes: [{ label: "XS", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "132.png"), img("1", "132.2.png"), img("1", "132.3.png")],
  },
  {
    id: "133",
    name: { en: "Baby Cherry Collar Romper", ar: "Baby Cherry Collar Romper", fr: "Baby Cherry Collar Romper" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Light Pink", ar: "فاتح وردي", fr: "Clair Rose" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
    ],
    sizes: [{ label: "6–9 months", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "133.png"), img("1", "133.2.png"), img("1", "133.3.png")],
  },
  {
    id: "134",
    name: { en: "Navy Glitter Triangle Bikini Set", ar: "Navy Glitter Triangle Bikini Set", fr: "Navy Glitter Triangle Bikini Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Navy Blue", ar: "كحلي / أزرق", fr: "Bleu marine / Bleu" },
    quantity: 1,
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "134.png"), img("1", "134.2.png"), img("1", "134.3.png")],
  },
  {
    id: "135",
    name: { en: "Striped Crochet Knit Vest & Shorts Set", ar: "Striped Crochet Knit Vest & Shorts Set", fr: "Striped Crochet Knit Vest & Shorts Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Beige", ar: "بيج", fr: "Beige" },
      { en: "Black", ar: "أسود", fr: "Noir" },
    ],
    sizes: [{ label: "XS", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "135.PNG"), img("1", "135.2.PNG"), img("1", "135.3.PNG")],
  },
  {
    id: "136",
    name: { en: "Cold Shoulder V-Neck Blouse", ar: "Cold Shoulder V-Neck Blouse", fr: "Cold Shoulder V-Neck Blouse" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "136.png"), img("1", "136.2.png"), img("1", "136.3.png")],
  },
  {
    id: "137",
    name: { en: "Floral Print Vacation Shorts Set", ar: "Floral Print Vacation Shorts Set", fr: "Floral Print Vacation Shorts Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Black", ar: "أسود", fr: "Noir" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
    ],
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "137.PNG"), img("1", "137.2.PNG"), img("1", "137.3.PNG")],
  },
  {
    id: "138",
    name: { en: "Baby Denim Romper / Jumpsuit", ar: "Baby Denim Romper / Jumpsuit", fr: "Baby Denim Romper / Jumpsuit" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Light Blue Denim", ar: "فاتح / أزرق / denim", fr: "Clair / Bleu / Denim" },
    sizes: [{ label: "6–9M", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "138.png"), img("1", "138.2.png"), img("1", "138.3.png")],
  },
  {
    id: "139",
    name: { en: "One-Shoulder Bikini Set", ar: "One-Shoulder Bikini Set", fr: "One-Shoulder Bikini Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "139.png"), img("1", "139.2.png"), img("1", "139.3.png")],
  },
  {
    id: "140",
    name: { en: "Red Ribbed Underwire Bikini Set with Scallop Trim", ar: "Red Ribbed Underwire Bikini Set with Scallop Trim", fr: "Red Ribbed Underwire Bikini Set with Scallop Trim" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Red", ar: "أحمر", fr: "Rouge" },
    sizes: [{ label: "s", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("1", "140.png"), img("1", "140.2.png"), img("1", "140.3.png")],
  },
  {
    id: "141",
    name: { en: "Strapless Bikini Set", ar: "Strapless Bikini Set", fr: "Strapless Bikini Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "بني", fr: "Marron" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "141.png"), img("2", "141.2.PNG"), img("2", "141.3.PNG")],
  },
  {
    id: "142",
    name: { en: "Padded String Bikini Set", ar: "Padded String Bikini Set", fr: "Padded String Bikini Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Burgundy", ar: "خمري", fr: "Bordeaux" },
    sizes: [{ label: "XS", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "142.png"), img("2", "142.2.png"), img("2", "142.3.png")],
  },
  {
    id: "143",
    name: { en: "Swim 3-Piece Halter Bikini Set with Cover-Up Skirt", ar: "Swim 3-Piece Halter Bikini Set with Cover-Up Skirt", fr: "Swim 3-Piece Halter Bikini Set with Cover-Up Skirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Dark Brown", ar: "غامق بني", fr: "Foncé Marron" },
      { en: "Baby Pink", ar: "بيبي وردي", fr: "Baby Rose" },
    ],
    sizes: [{ label: "XS", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "143.png"), img("2", "143.1.png"), img("2", "143.2.PNG"), img("2", "143.2.2.png"), img("2", "143.3.PNG"), img("2", "143.3.3.png")],
  },
  {
    id: "144",
    name: { en: "Women’s Ruched Wrap Mini Skirt", ar: "Women’s Ruched Wrap Mini Skirt", fr: "Women’s Ruched Wrap Mini Skirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Chocolate Brown", ar: "chocolate / بني", fr: "Chocolate / Marron" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "144.png"), img("2", "144.2.png"), img("2", "144.3.png")],
  },
  {
    id: "145",
    name: { en: "Girls 3-Piece Houndstooth Skirt Set", ar: "Girls 3-Piece Houndstooth Skirt Set", fr: "Girls 3-Piece Houndstooth Skirt Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Red & Black", ar: "أحمر / & / أسود", fr: "Rouge / & / Noir" },
    sizes: [{ label: "2–3Y", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "145.png"), img("2", "145.2.png"), img("2", "145.3.png")],
  },
  {
    id: "146",
    name: { en: "Baby Girls Floral Corduroy Overall Set with Hat", ar: "Baby Girls Floral Corduroy Overall Set with Hat", fr: "Baby Girls Floral Corduroy Overall Set with Hat" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Sage Green", ar: "sage / أخضر", fr: "Sage / Vert" },
    sizes: [{ label: "6–9M", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "146.png"), img("2", "146.2.PNG"), img("2", "146.3.PNG")],
  },
  {
    id: "147",
    name: { en: "Girls 2-Piece Lace Collar Cardigan & Pleated Skirt Set", ar: "Girls 2-Piece Lace Collar Cardigan & Pleated Skirt Set", fr: "Girls 2-Piece Lace Collar Cardigan & Pleated Skirt Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Light Grey", ar: "فاتح رمادي", fr: "Clair Gris" },
      { en: "Black", ar: "أسود", fr: "Noir" },
    ],
    sizes: [{ label: "5Years", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "147.png"), img("2", "147.2.png"), img("2", "147.3.png")],
  },
  {
    id: "148",
    name: { en: "Women’s Sleeveless Faux Leather Belted Vest", ar: "Women’s Sleeveless Faux Leather Belted Vest", fr: "Women’s Sleeveless Faux Leather Belted Vest" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 22.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "148.png"), img("2", "148.2.png"), img("2", "148.3.png")],
  },
  {
    id: "149",
    name: { en: "Women’s Crochet Knit Maxi Dress", ar: "Women’s Crochet Knit Maxi Dress", fr: "Women’s Crochet Knit Maxi Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Beige", ar: "بيج", fr: "Beige" },
      { en: "Apricot with Black Stripes", ar: "Apricot with أسود Stripes", fr: "Apricot with Noir Stripes" },
    ],
    sizes: [{ label: "XS", qty: 1 }],
    originalPrice: 22.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "149.png"), img("2", "149.2.png"), img("2", "149.3.png")],
  },
  {
    id: "150",
    name: { en: "Wall Mounted WiFi Router Storage Holder", ar: "Wall Mounted WiFi Router Storage Holder", fr: "Wall Mounted WiFi Router Storage Holder" },
    category: "shein",
    sheinCategory: "others",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    quantity: 1,
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "150.png"), img("2", "150.2.png")],
  },
  {
    id: "151",
    name: { en: "Kids Chunky Sneakers", ar: "Kids Chunky Sneakers", fr: "Kids Chunky Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "EUR 26", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "151.png"), img("2", "151.2.png"), img("2", "151.3.png")],
  },
  {
    id: "152",
    name: { en: "Kids Bow Loafers", ar: "Kids Bow Loafers", fr: "Kids Bow Loafers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "EUR 28", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "152.png"), img("2", "152.2.png"), img("2", "152.3.png")],
  },
  {
    id: "153",
    name: { en: "Window Cleaning Squeegee / Glass Wiper", ar: "Window Cleaning Squeegee / Glass Wiper", fr: "Window Cleaning Squeegee / Glass Wiper" },
    category: "shein",
    sheinCategory: "others",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 8.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "153.PNG"), img("2", "153.2.PNG")],
  },
  {
    id: "154",
    name: { en: "Faux Fur Mini Handbag / Shoulder Bag", ar: "Faux Fur Mini Handbag / Shoulder Bag", fr: "Faux Fur Mini Handbag / Shoulder Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Beige", ar: "بيج", fr: "Beige" },
    quantity: 1,
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "154.png"), img("2", "154.2.png")],
  },
  {
    id: "155",
    name: { en: "Women’s White Turtle Print Halter Tank Top", ar: "Women’s White Turtle Print Halter Tank Top", fr: "Women’s White Turtle Print Halter Tank Top" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "155.png"), img("2", "155.2.png"), img("2", "155.3.png")],
  },
  {
    id: "156",
    name: { en: "Baby Girls White Lace Collar Blouse", ar: "Baby Girls White Lace Collar Blouse", fr: "Baby Girls White Lace Collar Blouse" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "6–9M", qty: 1 }],
    originalPrice: 8.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "156.png"), img("2", "156.2.png"), img("2", "156.3.png")],
  },
  {
    id: "157",
    name: { en: "Women’s White Sea Shell Embroidered T-Shirt", ar: "Women’s White Sea Shell Embroidered T-Shirt", fr: "Women’s White Sea Shell Embroidered T-Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 8.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "157.png"), img("2", "157.2.png"), img("2", "157.3.png")],
  },
  {
    id: "158",
    name: { en: "Product Name: Girls Brown Wide Leg Jeans", ar: "Product Name: Girls Brown Wide Leg Jeans", fr: "Product Name: Girls Brown Wide Leg Jeans" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "بني", fr: "Marron" },
    sizes: [{ label: "11Y", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "158.png"), img("2", "158.2.png"), img("2", "158.3.png")],
  },
  {
    id: "159",
    name: { en: "Product Name: Women’s Pink Smocked Eyelet Tube Dress", ar: "Product Name: Women’s Pink Smocked Eyelet Tube Dress", fr: "Product Name: Women’s Pink Smocked Eyelet Tube Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Pink", ar: "وردي", fr: "Rose" },
    sizes: [{ label: "XS", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "159.png"), img("2", "159.2.png"), img("2", "159.3.png")],
  },
  {
    id: "160",
    name: { en: "Product Name: Women’s White Pleated Tennis Skirt", ar: "Product Name: Women’s White Pleated Tennis Skirt", fr: "Product Name: Women’s White Pleated Tennis Skirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "160.png"), img("2", "160.2.png"), img("2", "160.3.png")],
  },
  {
    id: "161",
    name: { en: "Women’s Animal Print Cami Maxi Dress", ar: "Women’s Animal Print Cami Maxi Dress", fr: "Women’s Animal Print Cami Maxi Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown Animal Print", ar: "بني / animal / print", fr: "Marron / Animal / Print" },
    sizes: [{ label: "XS", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "161.png"), img("2", "161.2.png"), img("2", "161.3.png")],
  },
  {
    id: "162",
    name: { en: "Women’s Ribbed Turtleneck Sweater", ar: "Women’s Ribbed Turtleneck Sweater", fr: "Women’s Ribbed Turtleneck Sweater" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Black", ar: "أسود", fr: "Noir" },
      { en: "brown", ar: "بني", fr: "Marron" },
      { en: "white", ar: "أبيض", fr: "Blanc" },
    ],
    sizes: [{ label: "each one large", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "162.png"), img("2", "162.1.png"), img("2", "162.1.1.png"), img("2", "162.2.png"), img("2", "162.2.2.png"), img("2", "162.3.png"), img("2", "162.3.3.png"), img("2", "162.4.png"), img("2", "162.4.4.png")],
  },
  {
    id: "163",
    name: { en: "Baby Beige Pearl Decor Mesh Hat", ar: "Baby Beige Pearl Decor Mesh Hat", fr: "Baby Beige Pearl Decor Mesh Hat" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Beige", ar: "بيج", fr: "Beige" },
    sizes: [{ label: "One Size", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "163.png")],
  },
  {
    id: "164",
    name: { en: "Telesin C03 Magnetic Selfie Ring Light", ar: "Telesin C03 Magnetic Selfie Ring Light", fr: "Telesin C03 Magnetic Selfie Ring Light" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "164.png"), img("2", "164.2.png"), img("2", "164.3.png")],
  },
  {
    id: "165",
    name: { en: "Girls Grey Wide Leg Jeans", ar: "Girls Grey Wide Leg Jeans", fr: "Girls Grey Wide Leg Jeans" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Grey", ar: "رمادي", fr: "Gris" },
    sizes: [{ label: "15Y", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "165.png"), img("2", "165.2.png"), img("2", "165.3.png")],
  },
  {
    id: "166",
    name: { en: "Baby Girls Blue Denim Scallop Romper", ar: "Baby Girls Blue Denim Scallop Romper", fr: "Baby Girls Blue Denim Scallop Romper" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Blue", ar: "أزرق", fr: "Bleu" },
    sizes: [{ label: "6–9M", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "166.png"), img("2", "166.2.png"), img("2", "166.3.png")],
  },
  {
    id: "167",
    name: { en: "Unity Women Ruffle Hem Swim Skirt", ar: "Unity Women Ruffle Hem Swim Skirt", fr: "Unity Women Ruffle Hem Swim Skirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 8.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "167.png"), img("2", "167.2.png"), img("2", "167.3.png")],
  },
  {
    id: "168",
    name: { en: "Baby Girl Pink Satin Asymmetrical Dress With Waist Belt", ar: "Baby Girl Pink Satin Asymmetrical Dress With Waist Belt", fr: "Baby Girl Pink Satin Asymmetrical Dress With Waist Belt" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Pink", ar: "وردي", fr: "Rose" },
    sizes: [{ label: "2–3Y", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "168.png"), img("2", "168.2.png"), img("2", "168.3.png")],
  },
  {
    id: "169",
    name: { en: "Women’s White Ruched Bandeau Bikini Set", ar: "Women’s White Ruched Bandeau Bikini Set", fr: "Women’s White Ruched Bandeau Bikini Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "169.png"), img("2", "169.2.png"), img("2", "169.3.png")],
  },
  {
    id: "170",
    name: { en: "Women’s White Ruched Strapless Ruffle Hem Dress", ar: "Women’s White Ruched Strapless Ruffle Hem Dress", fr: "Women’s White Ruched Strapless Ruffle Hem Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "XS", qty: 1 }],
    originalPrice: 22.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "170.png"), img("2", "170.2.png"), img("2", "170.3.png")],
  },
  {
    id: "171",
    name: { en: "Silver Lightning Bolt Pendant Necklace", ar: "Silver Lightning Bolt Pendant Necklace", fr: "Silver Lightning Bolt Pendant Necklace" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Silver", ar: "فضي", fr: "Argenté" },
    sizes: [{ label: "One Size", qty: 1 }],
    originalPrice: 4.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "171.png")],
  },
  {
    id: "172",
    name: { en: "White Folding Hand Fan Set", ar: "White Folding Hand Fan Set", fr: "White Folding Hand Fan Set" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Beige", ar: "بيج", fr: "Beige" },
    ],
    sizes: [{ label: "5 pieces set", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "172.png"), img("2", "172.2.png")],
  },
  {
    id: "173",
    name: { en: "Baby Printed Long Sleeve Feeding Bib", ar: "Baby Printed Long Sleeve Feeding Bib", fr: "Baby Printed Long Sleeve Feeding Bib" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Pink", ar: "وردي", fr: "Rose" },
    ],
    sizes: [{ label: "One Size", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "173.png"), img("2", "173.2.png"), img("2", "173.3.png")],
  },
  {
    id: "174",
    name: { en: "Reusable Silicone Nipple Covers Set", ar: "Reusable Silicone Nipple Covers Set", fr: "Reusable Silicone Nipple Covers Set" },
    category: "shein",
    sheinCategory: "others",
    authentic: false,
    discountPct: 30,
    color: { en: "Nude", ar: "nude", fr: "Nude" },
    sizes: [{ label: "One Size 6 pairs set", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "174.png")],
  },
  {
    id: "175",
    name: { en: "Kids Bow Decor Knee High Socks Set", ar: "Kids Bow Decor Knee High Socks Set", fr: "Kids Bow Decor Knee High Socks Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Grey", ar: "رمادي", fr: "Gris" },
      { en: "Black", ar: "أسود", fr: "Noir" },
    ],
    sizes: [{ label: "4–7Y", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "175.png"), img("2", "175.2.png"), img("2", "175.3.png")],
  },
  {
    id: "176",
    name: { en: "Baby Black Fishnet Knee High Socks", ar: "Baby Black Fishnet Knee High Socks", fr: "Baby Black Fishnet Knee High Socks" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "6–12M", qty: 1 }],
    originalPrice: 4.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "176.png"), img("2", "176.2.png"), img("2", "176.3.png")],
  },
  {
    id: "177",
    name: { en: "Gold Heart Shaped Mini Spoon Set", ar: "Gold Heart Shaped Mini Spoon Set", fr: "Gold Heart Shaped Mini Spoon Set" },
    category: "shein",
    sheinCategory: "others",
    authentic: false,
    discountPct: 30,
    color: { en: "Gold", ar: "ذهبي", fr: "Doré" },
    sizes: [{ label: "One Size", qty: 1 }],
    originalPrice: 2.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "177.png"), img("2", "177.2.png")],
  },
  {
    id: "178",
    name: { en: "SHEGLAM Like Magic 12HR Full Coverage Concealer", ar: "SHEGLAM Like Magic 12HR Full Coverage Concealer", fr: "SHEGLAM Like Magic 12HR Full Coverage Concealer" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    color: { en: "Beige", ar: "بيج", fr: "Beige" },
    quantity: 1,
    originalPrice: 4.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "178.png")],
  },
  {
    id: "179",
    name: { en: "TOPK IPX8 Waterproof Floating Phone Pouch", ar: "TOPK IPX8 Waterproof Floating Phone Pouch", fr: "TOPK IPX8 Waterproof Floating Phone Pouch" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "One Size", qty: 1 }],
    originalPrice: 4.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "179.png"), img("2", "179.2.JPG")],
  },
  {
    id: "180",
    name: { en: "Women’s Apricot Scallop Strapless Bra", ar: "Women’s Apricot Scallop Strapless Bra", fr: "Women’s Apricot Scallop Strapless Bra" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Apricot", ar: "apricot", fr: "Apricot" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 8.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "180.png"), img("2", "180.2.png"), img("2", "180.3.png")],
  },
  {
    id: "181",
    name: { en: "Padded String Bikini Set", ar: "Padded String Bikini Set", fr: "Padded String Bikini Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "brown", ar: "بني", fr: "Marron" },
    sizes: [{ label: "XS", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "181.png"), img("2", "181.2.png"), img("2", "181.3.png")],
  },
  {
    id: "182",
    name: { en: "Baby Fruit & Vegetable Teething Pacifier Feeder", ar: "Baby Fruit & Vegetable Teething Pacifier Feeder", fr: "Baby Fruit & Vegetable Teething Pacifier Feeder" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Blue", ar: "أزرق", fr: "Bleu" },
    quantity: 1,
    originalPrice: 2.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "182.png")],
  },
  {
    id: "183",
    name: { en: "Women’s Black One Shoulder Bikini Set", ar: "Women’s Black One Shoulder Bikini Set", fr: "Women’s Black One Shoulder Bikini Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "183.png"), img("2", "183.2.png"), img("2", "183.3.png")],
  },
  {
    id: "184",
    name: { en: "All My Hair Stuff PVC Travel Organizer Bag", ar: "All My Hair Stuff PVC Travel Organizer Bag", fr: "All My Hair Stuff PVC Travel Organizer Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 3.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "184.png"), img("2", "184.2.png")],
  },
  {
    id: "185",
    name: { en: "Nail Drill Bit Disinfection Box", ar: "Nail Drill Bit Disinfection Box", fr: "Nail Drill Bit Disinfection Box" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    color: { en: "Grey", ar: "رمادي", fr: "Gris" },
    quantity: 1,
    originalPrice: 4.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "185.png")],
  },
  {
    id: "186",
    name: { en: "Kids Multicolor Bow Hair Clip Set", ar: "Kids Multicolor Bow Hair Clip Set", fr: "Kids Multicolor Bow Hair Clip Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "متعدد الألوان", fr: "Multicolore" },
    sizes: [{ label: "30 pcs set", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "186.png"), img("2", "186.2.png")],
  },
  {
    id: "187",
    name: { en: "Toddler Girls Blue Ribbed Turtleneck Top & Pants Set", ar: "Toddler Girls Blue Ribbed Turtleneck Top & Pants Set", fr: "Toddler Girls Blue Ribbed Turtleneck Top & Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Blue", ar: "أزرق", fr: "Bleu" },
    sizes: [{ label: "2–3Y", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "187.png"), img("2", "187.2.png"), img("2", "187.3.png")],
  },
  {
    id: "188",
    name: { en: "Extendable Microfiber Duster", ar: "Extendable Microfiber Duster", fr: "Extendable Microfiber Duster" },
    category: "shein",
    sheinCategory: "others",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "188.png")],
  },
  {
    id: "189",
    name: { en: "Women’s Burgundy Chunky Chelsea Boots", ar: "Women’s Burgundy Chunky Chelsea Boots", fr: "Women’s Burgundy Chunky Chelsea Boots" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Burgundy", ar: "خمري", fr: "Bordeaux" },
    sizes: [{ label: "39", qty: 1 }],
    originalPrice: 25.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "189.png"), img("2", "189.2.png"), img("2", "189..3.png")],
  },
  {
    id: "190",
    name: { en: "Kids Divided Plate With Fork Set", ar: "Kids Divided Plate With Fork Set", fr: "Kids Divided Plate With Fork Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Pink", ar: "وردي", fr: "Rose" },
      { en: "Yellow", ar: "أصفر", fr: "Jaune" },
    ],
    quantity: 1,
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "190.png")],
  },
  {
    id: "191",
    name: { en: "Women’s Strapless Ruffle Mini Dress", ar: "Women’s Strapless Ruffle Mini Dress", fr: "Women’s Strapless Ruffle Mini Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "بني", fr: "Marron" },
    sizes: [{ label: "XS", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "191.png"), img("2", "191.2.png"), img("2", "191.3.png")],
  },
  {
    id: "192",
    name: { en: "Black Textured Underwire Bikini Set with Side Tie Bottom", ar: "Black Textured Underwire Bikini Set with Side Tie Bottom", fr: "Black Textured Underwire Bikini Set with Side Tie Bottom" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "xs", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "192.png"), img("2", "192.2.png"), img("2", "192.3.png")],
  },
  {
    id: "193",
    name: { en: "Clear iPhone Case with Funny Dog Print", ar: "Clear iPhone Case with Funny Dog Print", fr: "Clear iPhone Case with Funny Dog Print" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Transparent", ar: "شفاف", fr: "Transparent" },
    quantity: 1,
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "193.png")],
  },
  {
    id: "194",
    name: { en: "7-Day Weekly Pill Organizer Ring Box", ar: "7-Day Weekly Pill Organizer Ring Box", fr: "7-Day Weekly Pill Organizer Ring Box" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 2.5,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "194.png"), img("2", "194.2.png")],
  },
  {
    id: "195",
    name: { en: "Mini Teddy Bear Stud Earrings", ar: "Mini Teddy Bear Stud Earrings", fr: "Mini Teddy Bear Stud Earrings" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "بني", fr: "Marron" },
    sizes: [{ label: "One Size / 1 Pair", qty: 1 }],
    originalPrice: 2.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "195.png")],
  },
  {
    id: "196",
    name: { en: "Stainless Steel Crescent Pot Strainer", ar: "Stainless Steel Crescent Pot Strainer", fr: "Stainless Steel Crescent Pot Strainer" },
    category: "shein",
    sheinCategory: "others",
    authentic: false,
    discountPct: 30,
    color: { en: "Silver", ar: "فضي", fr: "Argenté" },
    sizes: [{ label: "33.5 × 13.5 cm", qty: 1 }],
    originalPrice: 3.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "196.png"), img("2", "196.2.png")],
  },
  {
    id: "197",
    name: { en: "Black Arrow Necklace, Bracelet & Ring Set", ar: "Black Arrow Necklace, Bracelet & Ring Set", fr: "Black Arrow Necklace, Bracelet & Ring Set" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    quantity: 1,
    originalPrice: 4.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "197.png")],
  },
  {
    id: "198",
    name: { en: "White Platform Casual Sneakers", ar: "White Platform Casual Sneakers", fr: "White Platform Casual Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Grey", ar: "رمادي", fr: "Gris" },
    ],
    sizes: [{ label: "CN35 / EU 35", qty: 1 }],
    originalPrice: 22.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "198.PNG"), img("2", "198.2.PNG"), img("2", "198.3.PNG")],
  },
  {
    id: "199",
    name: { en: "Crochet Sunflower Shoulder Bag", ar: "Crochet Sunflower Shoulder Bag", fr: "Crochet Sunflower Shoulder Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Cream", ar: "كريمي", fr: "Crème" },
      { en: "Yellow", ar: "أصفر", fr: "Jaune" },
      { en: "Brown", ar: "بني", fr: "Marron" },
    ],
    quantity: 1,
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("2", "199.PNG"), img("2", "199.2.PNG")],
  },
  {
    id: "200",
    name: { en: "Mini Floral Print Tote Bag", ar: "Mini Floral Print Tote Bag", fr: "Mini Floral Print Tote Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    quantity: 1,
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "200.PNG"), img("3", "200.2.PNG"), img("3", "200.3.PNG")],
  },
  {
    id: "201",
    name: { en: "Women’s Black Nylon Multifunctional Tote Bag", ar: "Women’s Black Nylon Multifunctional Tote Bag", fr: "Women’s Black Nylon Multifunctional Tote Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "31 × 28 × 11 cm", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "201.PNG"), img("3", "201.2.PNG")],
  },
  {
    id: "202",
    name: { en: "Girls Pink Bow Casual Sneakers", ar: "Girls Pink Bow Casual Sneakers", fr: "Girls Pink Bow Casual Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Pink", ar: "وردي", fr: "Rose" },
    ],
    sizes: [{ label: "EU 27", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "202.PNG"), img("3", "202.2.PNG"), img("3", "202.3.PNG"), img("3", "202.4.PNG")],
  },
  {
    id: "203",
    name: { en: "Wooden Alphabet Puzzle Board", ar: "Wooden Alphabet Puzzle Board", fr: "Wooden Alphabet Puzzle Board" },
    category: "shein",
    sheinCategory: "others",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 8.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "203.PNG")],
  },
  {
    id: "204",
    name: { en: "Minimalist Canvas Tote Bag with Pendant", ar: "Minimalist Canvas Tote Bag with Pendant", fr: "Minimalist Canvas Tote Bag with Pendant" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    quantity: 1,
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "204.png"), img("3", "204.2.PNG")],
  },
  {
    id: "205",
    name: { en: "Foldable Round Sunglasses Set", ar: "Foldable Round Sunglasses Set", fr: "Foldable Round Sunglasses Set" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Black", ar: "أسود", fr: "Noir" },
      { en: "Brown", ar: "بني", fr: "Marron" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
    ],
    quantity: 1,
    originalPrice: 7.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "205.PNG"), img("3", "205.2.PNG"), img("3", "205.3.PNG")],
  },
  {
    id: "206",
    name: { en: "Paisley Print Fringe Scarf", ar: "Paisley Print Fringe Scarf", fr: "Paisley Print Fringe Scarf" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Dark Blue", ar: "غامق أزرق", fr: "Foncé Bleu" },
      { en: "Brown", ar: "بني", fr: "Marron" },
    ],
    sizes: [{ label: "One Size", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "206.PNG"), img("3", "206.2.PNG")],
  },
  {
    id: "207",
    name: { en: "Heart Pattern Phone Case for Xiaomi Poco X5 Pro", ar: "Heart Pattern Phone Case for Xiaomi Poco X5 Pro", fr: "Heart Pattern Phone Case for Xiaomi Poco X5 Pro" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Brown", ar: "بني", fr: "Marron" },
      { en: "Black", ar: "أسود", fr: "Noir" },
    ],
    sizes: [{ label: "Xiaomi Poco X5 Pro", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "207.PNG")],
  },
  {
    id: "208",
    name: { en: "Press-On False Nails Set", ar: "Press-On False Nails Set", fr: "Press-On False Nails Set" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Black", ar: "أسود", fr: "Noir" },
      { en: "Nude", ar: "نود", fr: "Nude" },
      { en: "Brown", ar: "بني", fr: "Marron" },
      { en: "Beige", ar: "بيج", fr: "Beige" },
    ],
    sizes: [{ label: "Mixed Sizes", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "208.jpg"), img("3", "208.2.PNG"), img("3", "208.3.PNG"), img("3", "208.4.PNG"), img("3", "208.5.PNG")],
  },
  {
    id: "209",
    name: { en: "Clear Magnetic Ring Phone Case for iPhone 13 Pro Max", ar: "Clear Magnetic Ring Phone Case for iPhone 13 Pro Max", fr: "Clear Magnetic Ring Phone Case for iPhone 13 Pro Max" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Transparent", ar: "شفاف", fr: "Transparent" },
      { en: "Blue", ar: "أزرق", fr: "Bleu" },
    ],
    sizes: [{ label: "iPhone 13 Pro Max", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "209.PNG")],
  },
  {
    id: "210",
    name: { en: "6D White Purple Tooth Powder", ar: "6D White Purple Tooth Powder", fr: "6D White Purple Tooth Powder" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    sizes: [{ label: "80ml", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "210.PNG")],
  },
  {
    id: "211",
    name: { en: "Eagle Logo Phone Case for Samsung Galaxy A32 4G", ar: "Eagle Logo Phone Case for Samsung Galaxy A32 4G", fr: "Eagle Logo Phone Case for Samsung Galaxy A32 4G" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "Samsung Galaxy A32 4G", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "211.PNG")],
  },
  {
    id: "212",
    name: { en: "Double-Sided Facial Cleansing Brush", ar: "Double-Sided Facial Cleansing Brush", fr: "Double-Sided Facial Cleansing Brush" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Pink", ar: "وردي", fr: "Rose" },
    ],
    quantity: 1,
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "212.PNG"), img("3", "212.2.PNG"), img("3", "212.3.PNG")],
  },
  {
    id: "213",
    name: { en: "Panda Print Phone Case for Redmi Note 14 4G", ar: "Panda Print Phone Case for Redmi Note 14 4G", fr: "Panda Print Phone Case for Redmi Note 14 4G" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Black", ar: "أسود", fr: "Noir" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
    ],
    sizes: [{ label: "Redmi Note 14 4G", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "213.PNG")],
  },
  {
    id: "214",
    name: { en: "Cartoon Eye Charger Cover & Cable Protector Set", ar: "Cartoon Eye Charger Cover & Cable Protector Set", fr: "Cartoon Eye Charger Cover & Cable Protector Set" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Transparent", ar: "شفاف", fr: "Transparent" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
    ],
    quantity: 1,
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "214.PNG"), img("3", "214.2.PNG"), img("3", "214.3.PNG")],
  },
  {
    id: "215",
    name: { en: "6pcs Women’s Faux Pearl Floral Headband Set", ar: "6pcs Women’s Faux Pearl Floral Headband Set", fr: "6pcs Women’s Faux Pearl Floral Headband Set" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "215.PNG"), img("3", "215.2.PNG"), img("3", "215.3.PNG")],
  },
  {
    id: "216",
    name: { en: "Teen Girls One-Shoulder Los Angeles Sweatshirt", ar: "Teen Girls One-Shoulder Los Angeles Sweatshirt", fr: "Teen Girls One-Shoulder Los Angeles Sweatshirt" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Deep Navy", ar: "deep / كحلي", fr: "Deep / Bleu marine" },
    sizes: [{ label: "15Y", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "216.PNG"), img("3", "216.2.PNG"), img("3", "216.3.PNG")],
  },
  {
    id: "217",
    name: { en: "Tween Girls Floral Long Sleeve Mesh Dress", ar: "Tween Girls Floral Long Sleeve Mesh Dress", fr: "Tween Girls Floral Long Sleeve Mesh Dress" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Pink", ar: "وردي", fr: "Rose" },
    sizes: [{ label: "5Y", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "217.PNG"), img("3", "217.2.PNG"), img("3", "217.3.PNG")],
  },
  {
    id: "218",
    name: { en: "Toddler Boys 2-Piece Sweater & Pants Set", ar: "Toddler Boys 2-Piece Sweater & Pants Set", fr: "Toddler Boys 2-Piece Sweater & Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Green", ar: "أخضر", fr: "Vert" },
      { en: "Beige", ar: "بيج", fr: "Beige" },
    ],
    sizes: [{ label: "2–3Y", qty: 1 }],
    originalPrice: 20.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "218.PNG"), img("3", "218.2.PNG"), img("3", "218.3.PNG")],
  },
  {
    id: "219",
    name: { en: "Toddler Girls Ruffle Top & Bow Jeans Set", ar: "Toddler Girls Ruffle Top & Bow Jeans Set", fr: "Toddler Girls Ruffle Top & Bow Jeans Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Burgundy", ar: "خمري", fr: "Bordeaux" },
      { en: "Blue", ar: "أزرق", fr: "Bleu" },
    ],
    sizes: [{ label: "18–24M", qty: 1 }],
    originalPrice: 20.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "219.PNG"), img("3", "219.2.PNG"), img("3", "219.3.PNG")],
  },
  {
    id: "220",
    name: { en: "Women’s Black Bow Flat Sandals", ar: "Women’s Black Bow Flat Sandals", fr: "Women’s Black Bow Flat Sandals" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "EU 38", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "220.PNG"), img("3", "220.2.PNG"), img("3", "220.3.PNG")],
  },
  {
    id: "221",
    name: { en: "Tween Girl Pearl Embellished Puff Sleeve Dress", ar: "Tween Girl Pearl Embellished Puff Sleeve Dress", fr: "Tween Girl Pearl Embellished Puff Sleeve Dress" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "9Y", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "221.PNG"), img("3", "221.2.PNG"), img("3", "221.3.PNG")],
  },
  {
    id: "222",
    name: { en: "Hooded Baby Towel Wrap", ar: "Hooded Baby Towel Wrap", fr: "Hooded Baby Towel Wrap" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Light Pink", ar: "فاتح / وردي", fr: "Clair / Rose" },
    quantity: 1,
    originalPrice: 8.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "222.PNG"), img("3", "222.2.PNG")],
  },
  {
    id: "223",
    name: { en: "Kids Velcro Casual Sneakers", ar: "Kids Velcro Casual Sneakers", fr: "Kids Velcro Casual Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Navy", ar: "كحلي", fr: "Bleu marine" },
      { en: "Brown", ar: "بني", fr: "Marron" },
    ],
    sizes: [{ label: "EU 24", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "223.PNG"), img("3", "223.2.PNG"), img("3", "223.3.PNG")],
  },
  {
    id: "224",
    name: { en: "Plus Size Black Bow Flat Sandals", ar: "Plus Size Black Bow Flat Sandals", fr: "Plus Size Black Bow Flat Sandals" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "EU 37", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "224.PNG"), img("3", "224.2.PNG")],
  },
  {
    id: "225",
    name: { en: "Mini Bowknot Crossbody Saddle Bag", ar: "Mini Bowknot Crossbody Saddle Bag", fr: "Mini Bowknot Crossbody Saddle Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "19 × 12.5 × 7 cm", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "225.PNG")],
  },
  {
    id: "226",
    name: { en: "Plastic Face-Shaped Hand Pen Holder", ar: "Plastic Face-Shaped Hand Pen Holder", fr: "Plastic Face-Shaped Hand Pen Holder" },
    category: "shein",
    sheinCategory: "others",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    quantity: 1,
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "226.PNG"), img("3", "226.2.PNG")],
  },
  {
    id: "227",
    name: { en: "Baby Ribbed Long Sleeve Tops Set", ar: "Baby Ribbed Long Sleeve Tops Set", fr: "Baby Ribbed Long Sleeve Tops Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Beige", ar: "بيج", fr: "Beige" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Black", ar: "أسود", fr: "Noir" },
      { en: "Pink", ar: "وردي", fr: "Rose" },
    ],
    sizes: [{ label: "6–9M", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "227.PNG"), img("3", "227.1.1.PNG"), img("3", "227.2.PNG"), img("3", "227.2.2.PNG"), img("3", "227.3.PNG"), img("3", "227.3.3.PNG"), img("3", "227.4.PNG"), img("3", "227.5.PNG"), img("3", "227.6.PNG"), img("3", "227.7.PNG"), img("3", "227.8.PNG"), img("3", "227.9.PNG")],
  },
  {
    id: "228",
    name: { en: "Satin Flower Hair Ribbon Set", ar: "Satin Flower Hair Ribbon Set", fr: "Satin Flower Hair Ribbon Set" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Light Green", ar: "فاتح / أخضر", fr: "Clair / Vert" },
    quantity: 1,
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "228.PNG"), img("3", "228.2.PNG")],
  },
  {
    id: "229",
    name: { en: "Matte Silicone Phone Case with Wrist Strap", ar: "Matte Silicone Phone Case with Wrist Strap", fr: "Matte Silicone Phone Case with Wrist Strap" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "Xiaomi Poco X5 Pro 5G", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "229.PNG"), img("3", "229.2.PNG")],
  },
  {
    id: "230",
    name: { en: "Kids Pink Velcro Casual Sneakers", ar: "Kids Pink Velcro Casual Sneakers", fr: "Kids Pink Velcro Casual Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Pink", ar: "وردي", fr: "Rose" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
    ],
    sizes: [{ label: "EU 32", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "230.PNG"), img("3", "230.2.PNG"), img("3", "230.3.PNG"), img("3", "230.4.PNG")],
  },
  {
    id: "231",
    name: { en: "Glitter Ring Phone Case for iPhone 11", ar: "Glitter Ring Phone Case for iPhone 11", fr: "Glitter Ring Phone Case for iPhone 11" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Gold", ar: "ذهبي", fr: "Doré" },
      { en: "Transparent", ar: "شفاف", fr: "Transparent" },
    ],
    sizes: [{ label: "iPhone 11", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "231.PNG"), img("3", "231.1.PNG")],
  },
  {
    id: "232",
    name: { en: "Bear Pattern Phone Case with Beaded Strap", ar: "Bear Pattern Phone Case with Beaded Strap", fr: "Bear Pattern Phone Case with Beaded Strap" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "Samsung Galaxy A53 5G", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "232.PNG")],
  },
  {
    id: "233",
    name: { en: "Baby Boy Long Sleeve Top & Pants Set", ar: "Baby Boy Long Sleeve Top & Pants Set", fr: "Baby Boy Long Sleeve Top & Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "بني", fr: "Marron" },
    sizes: [{ label: "12–18M", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "233.PNG"), img("3", "233.2.PNG"), img("3", "233.3.PNG")],
  },
  {
    id: "234",
    name: { en: "Women Brown Chiffon Cape Overlay Top", ar: "Women Brown Chiffon Cape Overlay Top", fr: "Women Brown Chiffon Cape Overlay Top" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "بني", fr: "Marron" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "234.PNG"), img("3", "234.2.PNG"), img("3", "234.3.PNG")],
  },
  {
    id: "235",
    name: { en: "Women Braided Handle Tote Bag", ar: "Women Braided Handle Tote Bag", fr: "Women Braided Handle Tote Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    quantity: 1,
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "235.PNG"), img("3", "235.2.PNG")],
  },
  {
    id: "236",
    name: { en: "2pcs Women Mesh Nightdress Set", ar: "2pcs Women Mesh Nightdress Set", fr: "2pcs Women Mesh Nightdress Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Purple", ar: "بنفسجي", fr: "Violet" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "236.PNG"), img("3", "236.2.PNG"), img("3", "236.3.PNG")],
  },
  {
    id: "237",
    name: { en: "Toddler Soft Bottom Sneakers", ar: "Toddler Soft Bottom Sneakers", fr: "Toddler Soft Bottom Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "EUR25", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "237.PNG"), img("3", "237.2.PNG"), img("3", "237.3.PNG")],
  },
  {
    id: "238",
    name: { en: "UV Protection Arm Sleeves Set", ar: "UV Protection Arm Sleeves Set", fr: "UV Protection Arm Sleeves Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "متعدد الألوان", fr: "Multicolore" },
    sizes: [{ label: "One Size", qty: 1 }],
    originalPrice: 9.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("3", "238.PNG"), img("3", "238.1.PNG"), img("3", "238.1.1.PNG"), img("3", "238.2.PNG"), img("3", "238.2.2.PNG"), img("3", "238.3.PNG"), img("3", "238.3.3.PNG"), img("3", "238.4.PNG"), img("3", "238.4.4.PNG"), img("3", "238.5.PNG"), img("3", "238.5.5.PNG"), img("3", "238.6.PNG"), img("3", "238.6.6.PNG")],
  },
  {
    id: "239",
    name: { en: "Pearl Bow iPhone Case with Wrist Strap", ar: "Pearl Bow iPhone Case with Wrist Strap", fr: "Pearl Bow iPhone Case with Wrist Strap" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "iPhone 13 Pro Max", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "239.PNG")],
  },
  {
    id: "240",
    name: { en: "Purple Butterfly Transparent iPhone Case", ar: "Purple Butterfly Transparent iPhone Case", fr: "Purple Butterfly Transparent iPhone Case" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Purple", ar: "بنفسجي", fr: "Violet" },
    sizes: [{ label: "iPhone 13 Pro Max", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "240.PNG")],
  },
  {
    id: "241",
    name: { en: "Blue Butterfly Transparent Phone Case", ar: "Blue Butterfly Transparent Phone Case", fr: "Blue Butterfly Transparent Phone Case" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Multicolor", ar: "متعدد", fr: "Multicolore" },
      { en: "Blue", ar: "أزرق", fr: "Bleu" },
    ],
    sizes: [{ label: "Redmi Note 13 4G", qty: 1 }],
    originalPrice: 8.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "241.PNG")],
  },
  {
    id: "242",
    name: { en: "Glitter Ring Holder Phone Case", ar: "Glitter Ring Holder Phone Case", fr: "Glitter Ring Holder Phone Case" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Blue", ar: "أزرق", fr: "Bleu" },
    sizes: [{ label: "iPhone 13 Pro Max", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "242.PNG")],
  },
  {
    id: "243",
    name: { en: "Syrian Eagle Phone Case with Wrist Strap", ar: "Syrian Eagle Phone Case with Wrist Strap", fr: "Syrian Eagle Phone Case with Wrist Strap" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "Redmi Note 14 Pro 5G", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "243.PNG")],
  },
  {
    id: "244",
    name: { en: "Magnetic Leather Texture Phone Case", ar: "Magnetic Leather Texture Phone Case", fr: "Magnetic Leather Texture Phone Case" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black with Orange Trim", ar: "أسود / with / برتقالي / trim", fr: "Noir / With / Orange / Trim" },
    sizes: [{ label: "iPhone 17 Pro Max", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "244.PNG")],
  },
  {
    id: "245",
    name: { en: "Mini Tote Crossbody Bag with Metal Lock Charm", ar: "Mini Tote Crossbody Bag with Metal Lock Charm", fr: "Mini Tote Crossbody Bag with Metal Lock Charm" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Dusty Blue", ar: "dusty / أزرق", fr: "Dusty / Bleu" },
    sizes: [{ label: "10 × 7 × 3 cm", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "245.PNG"), img("4", "245.2.PNG")],
  },
  {
    id: "246",
    name: { en: "Gold-Plated Leaf Jewelry Set", ar: "Gold-Plated Leaf Jewelry Set", fr: "Gold-Plated Leaf Jewelry Set" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Gold", ar: "ذهبي", fr: "Doré" },
    quantity: 1,
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "246.png"), img("4", "246.2.png")],
  },
  {
    id: "247",
    name: { en: "Fashion Wheat Design Cuff Bangle & Ring Set", ar: "Fashion Wheat Design Cuff Bangle & Ring Set", fr: "Fashion Wheat Design Cuff Bangle & Ring Set" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Gold", ar: "ذهبي", fr: "Doré" },
    quantity: 1,
    originalPrice: 8.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "247.PNG"), img("4", "247.2.PNG")],
  },
  {
    id: "248",
    name: { en: "Foldable Shockproof Tablet Case", ar: "Foldable Shockproof Tablet Case", fr: "Foldable Shockproof Tablet Case" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "Samsung Galaxy Tab S8+ 2022 / 12.4 inch", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "248.PNG")],
  },
  {
    id: "249",
    name: { en: "LED Starry Sky Moon Night Light Projector", ar: "LED Starry Sky Moon Night Light Projector", fr: "LED Starry Sky Moon Night Light Projector" },
    category: "shein",
    sheinCategory: "others",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    quantity: 1,
    originalPrice: 7.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "249.PNG")],
  },
  {
    id: "250",
    name: { en: "Voxier Advanced Lash & Brow Serum", ar: "Voxier Advanced Lash & Brow Serum", fr: "Voxier Advanced Lash & Brow Serum" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    sizes: [{ label: "0.17 fl oz / 5 ml", qty: 2 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "250.PNG")],
  },
  {
    id: "251",
    name: { en: "24pcs Floral Press-On Nails Set", ar: "24pcs Floral Press-On Nails Set", fr: "24pcs Floral Press-On Nails Set" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Brown", ar: "بني", fr: "Marron" },
      { en: "Clear Floral", ar: "شفاف Floral", fr: "Transparent Floral" },
    ],
    sizes: [{ label: "24 reusable nails", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "251.PNG"), img("4", "251.2.PNG")],
  },
  {
    id: "252",
    name: { en: "24pcs Elegant Floral Press-On Nails Set", ar: "24pcs Elegant Floral Press-On Nails Set", fr: "24pcs Elegant Floral Press-On Nails Set" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Nude Beige", ar: "نود بيج", fr: "Nude Beige" },
      { en: "White Floral", ar: "أبيض Floral", fr: "Blanc Floral" },
    ],
    sizes: [{ label: "24 reusable nails", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "252.PNG"), img("4", "252.2.PNG")],
  },
  {
    id: "253",
    name: { en: "MELAO Beard Oil", ar: "MELAO Beard Oil", fr: "MELAO Beard Oil" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Amber bottle", ar: "Amber bottle", fr: "Amber bottle" },
      { en: "Black cap", ar: "أسود cap", fr: "Noir cap" },
    ],
    sizes: [{ label: "60ml / 2.03 fl oz", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "253.PNG"), img("4", "253.2.PNG")],
  },
  {
    id: "254",
    name: { en: "9H Glass / Aviation Aluminum Camera Lens Protector", ar: "9H Glass / Aviation Aluminum Camera Lens Protector", fr: "9H Glass / Aviation Aluminum Camera Lens Protector" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Orange", ar: "برتقالي", fr: "Orange" },
    sizes: [{ label: "iPhone 17 Pro Max", qty: 1 }],
    originalPrice: 3.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "254.PNG")],
  },
  {
    id: "255",
    name: { en: "Pudaier Lip Liner Pencil + Sensory Party Lip Gloss Set", ar: "Pudaier Lip Liner Pencil + Sensory Party Lip Gloss Set", fr: "Pudaier Lip Liner Pencil + Sensory Party Lip Gloss Set" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Red", ar: "أحمر", fr: "Rouge" },
      { en: "Brown Nude", ar: "بني نود", fr: "Marron Nude" },
    ],
    sizes: [{ label: "2 pcs set", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "255.PNG"), img("4", "255.2.PNG")],
  },
  {
    id: "256",
    name: { en: "9-Slot Ultra-Thin Zipper Credit Card Holder / Men’s Wallet", ar: "9-Slot Ultra-Thin Zipper Credit Card Holder / Men’s Wallet", fr: "9-Slot Ultra-Thin Zipper Credit Card Holder / Men’s Wallet" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Dark Brown", ar: "غامق / بني", fr: "Foncé / Marron" },
    quantity: 1,
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "256.PNG"), img("4", "256.2.PNG")],
  },
  {
    id: "257",
    name: { en: "French Romantic Lace Sun Protection Arm Sleeves", ar: "French Romantic Lace Sun Protection Arm Sleeves", fr: "French Romantic Lace Sun Protection Arm Sleeves" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "One Size / Pair", qty: 1 }],
    originalPrice: 4.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "257.PNG"), img("4", "257.2.PNG")],
  },
  {
    id: "258",
    name: { en: "Black Punk Stackable Ring Set", ar: "Black Punk Stackable Ring Set", fr: "Black Punk Stackable Ring Set" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "One Size 24 pieces set", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "258.PNG"), img("4", "258.2.jpeg")],
  },
  {
    id: "259",
    name: { en: "Science Charm Keychain", ar: "Science Charm Keychain", fr: "Science Charm Keychain" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Silver", ar: "فضي", fr: "Argenté" },
    quantity: 2,
    originalPrice: 3.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "259.PNG")],
  },
  {
    id: "260",
    name: { en: "18K Gold Plated Stainless Steel Baroque Evil Eye Ring", ar: "18K Gold Plated Stainless Steel Baroque Evil Eye Ring", fr: "18K Gold Plated Stainless Steel Baroque Evil Eye Ring" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Gold", ar: "ذهبي", fr: "Doré" },
      { en: "Black", ar: "أسود", fr: "Noir" },
    ],
    sizes: [{ label: "Adjustable", qty: 1 }],
    originalPrice: 3.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "260.PNG")],
  },
  {
    id: "261",
    name: { en: "Minimalist Sunburst Pendant Necklace", ar: "Minimalist Sunburst Pendant Necklace", fr: "Minimalist Sunburst Pendant Necklace" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Gold", ar: "ذهبي", fr: "Doré" },
    quantity: 1,
    originalPrice: 4.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "261.PNG")],
  },
  {
    id: "262",
    name: { en: "Silver Rhinestone Wrap Ring Set", ar: "Silver Rhinestone Wrap Ring Set", fr: "Silver Rhinestone Wrap Ring Set" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Silver", ar: "فضي", fr: "Argenté" },
    sizes: [{ label: "One Size", qty: 1 }],
    originalPrice: 2.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "262.PNG")],
  },
  {
    id: "263",
    name: { en: "Vintage Hollow Sun God Open Ring", ar: "Vintage Hollow Sun God Open Ring", fr: "Vintage Hollow Sun God Open Ring" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Gold", ar: "ذهبي", fr: "Doré" },
    sizes: [{ label: "Adjustable", qty: 1 }],
    originalPrice: 2.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "263.PNG")],
  },
  {
    id: "264",
    name: { en: "16-Piece Gold Sparkling Ring Set", ar: "16-Piece Gold Sparkling Ring Set", fr: "16-Piece Gold Sparkling Ring Set" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Gold", ar: "ذهبي", fr: "Doré" },
    sizes: [{ label: "One size", qty: 1 }],
    originalPrice: 3.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "264.PNG"), img("4", "264.2.PNG")],
  },
  {
    id: "265",
    name: { en: "Gold Flower Decor Cuff Ring", ar: "Gold Flower Decor Cuff Ring", fr: "Gold Flower Decor Cuff Ring" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Gold", ar: "ذهبي", fr: "Doré" },
    sizes: [{ label: "Adjustable / One size", qty: 1 }],
    originalPrice: 1.5,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "265.PNG")],
  },
  {
    id: "266",
    name: { en: "Breathable Micropore Tape / Eyelash Extension Tape", ar: "Breathable Micropore Tape / Eyelash Extension Tape", fr: "Breathable Micropore Tape / Eyelash Extension Tape" },
    category: "shein",
    sheinCategory: "others",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Beige", ar: "بيج", fr: "Beige" },
      { en: "Skin color", ar: "Skin color", fr: "Skin color" },
    ],
    quantity: 1,
    originalPrice: 1.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "266.PNG")],
  },
  {
    id: "267",
    name: { en: "Engineer Tool Keychain / Engineering Keyring", ar: "Engineer Tool Keychain / Engineering Keyring", fr: "Engineer Tool Keychain / Engineering Keyring" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Silver", ar: "فضي", fr: "Argenté" },
    quantity: 1,
    originalPrice: 1.5,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "267.PNG")],
  },
  {
    id: "268",
    name: { en: "50pcs Vintage Art Washi Stickers", ar: "50pcs Vintage Art Washi Stickers", fr: "50pcs Vintage Art Washi Stickers" },
    category: "shein",
    sheinCategory: "others",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 2.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "268.PNG"), img("4", "268.2.PNG"), img("4", "268.3.PNG")],
  },
  {
    id: "269",
    name: { en: "Women’s White Cherry Embroidered Hoodie", ar: "Women’s White Cherry Embroidered Hoodie", fr: "Women’s White Cherry Embroidered Hoodie" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "269.PNG"), img("4", "269.2.PNG"), img("4", "269.3.PNG")],
  },
  {
    id: "270",
    name: { en: "Women Off Shoulder Long Sleeve Front Tie Bodycon Maxi Dress", ar: "Women Off Shoulder Long Sleeve Front Tie Bodycon Maxi Dress", fr: "Women Off Shoulder Long Sleeve Front Tie Bodycon Maxi Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Burgundy", ar: "خمري", fr: "Bordeaux" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "270.PNG"), img("4", "270.2.PNG"), img("4", "270.3.PNG")],
  },
  {
    id: "271",
    name: { en: "Baby Corduroy Jogger Pants", ar: "Baby Corduroy Jogger Pants", fr: "Baby Corduroy Jogger Pants" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Black", ar: "أسود", fr: "Noir" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Dark Brown", ar: "غامق بني", fr: "Foncé Marron" },
    ],
    sizes: [{ label: "12–18 months", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "271.PNG"), img("4", "271.1.1.PNG"), img("4", "271.2.PNG"), img("4", "271.2.2.PNG"), img("4", "271.3.PNG"), img("4", "271.4.PNG"), img("4", "271.5.PNG"), img("4", "271.7.PNG")],
  },
  {
    id: "272",
    name: { en: "Couple Line Art Phone Case", ar: "Couple Line Art Phone Case", fr: "Couple Line Art Phone Case" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "272.PNG")],
  },
  {
    id: "273",
    name: { en: "Women’s Flared Pants", ar: "Women’s Flared Pants", fr: "Women’s Flared Pants" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Apricot", ar: "apricot", fr: "Apricot" },
    sizes: [{ label: "Petite L", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "273.PNG"), img("4", "273.2.PNG"), img("4", "273.3.PNG")],
  },
  {
    id: "274",
    name: { en: "Baby 3 Pieces Hoodie, Jogger Pants & Puffer Vest Set", ar: "Baby 3 Pieces Hoodie, Jogger Pants & Puffer Vest Set", fr: "Baby 3 Pieces Hoodie, Jogger Pants & Puffer Vest Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Beige", ar: "بيج", fr: "Beige" },
      { en: "Brown", ar: "بني", fr: "Marron" },
    ],
    sizes: [{ label: "6–9M", qty: 1 }],
    originalPrice: 20.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "274.PNG"), img("4", "274.2.PNG"), img("4", "274.3.PNG")],
  },
  {
    id: "275",
    name: { en: "Baby Boys Printed Sweatshirt & Jogger Pants Set", ar: "Baby Boys Printed Sweatshirt & Jogger Pants Set", fr: "Baby Boys Printed Sweatshirt & Jogger Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Black /", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "9–12M", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "275.PNG"), img("4", "275.2.PNG"), img("4", "275.3.PNG")],
  },
  {
    id: "276",
    name: { en: "Baby Girls Cable Knit Sweater & Pants Set", ar: "Baby Girls Cable Knit Sweater & Pants Set", fr: "Baby Girls Cable Knit Sweater & Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Pink", ar: "وردي", fr: "Rose" },
    sizes: [{ label: "6–9M", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "276.PNG"), img("4", "276.2.PNG"), img("4", "276.3.PNG")],
  },
  {
    id: "277",
    name: { en: "3 Pairs Baby/Toddler Girls Cotton Tights", ar: "3 Pairs Baby/Toddler Girls Cotton Tights", fr: "3 Pairs Baby/Toddler Girls Cotton Tights" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Black", ar: "أسود", fr: "Noir" },
      { en: "Pink", ar: "وردي", fr: "Rose" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
    ],
    sizes: [{ label: "1–2Y", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "277.PNG"), img("4", "277.2.PNG"), img("4", "277.3.PNG")],
  },
  {
    id: "278",
    name: { en: "French Style Lace Trim Embroidered Floral Blouse", ar: "French Style Lace Trim Embroidered Floral Blouse", fr: "French Style Lace Trim Embroidered Floral Blouse" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Apricot", ar: "apricot", fr: "Apricot" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "278.PNG"), img("4", "278.2.PNG"), img("4", "278.3.PNG")],
  },
  {
    id: "279",
    name: { en: "Women’s Oversized Plaid Button-Up Shirt", ar: "Women’s Oversized Plaid Button-Up Shirt", fr: "Women’s Oversized Plaid Button-Up Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Yellow", ar: "أصفر", fr: "Jaune" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "279.PNG"), img("4", "279.2.PNG"), img("4", "279.3.PNG")],
  },
  {
    id: "280",
    name: { en: "Baby Sweatpants Jogger Pants", ar: "Baby Sweatpants Jogger Pants", fr: "Baby Sweatpants Jogger Pants" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Black", ar: "أسود", fr: "Noir" },
      { en: "Light Grey", ar: "فاتح رمادي", fr: "Clair Gris" },
      { en: "Dark Grey", ar: "غامق رمادي", fr: "Foncé Gris" },
    ],
    sizes: [{ label: "12–18M", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("4", "280.PNG"), img("4", "280.1.1.PNG"), img("4", "280.2.PNG"), img("4", "280.2.2.PNG"), img("4", "280.3.PNG"), img("4", "280.4.PNG"), img("4", "280.5.PNG"), img("4", "280.6.PNG"), img("4", "280.7.PNG"), img("4", "280.8.PNG")],
  },
  {
    id: "281",
    name: { en: "Baby Girls Bow Print Lace Hem Long Sleeve Top", ar: "Baby Girls Bow Print Lace Hem Long Sleeve Top", fr: "Baby Girls Bow Print Lace Hem Long Sleeve Top" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Navy Blue", ar: "كحلي / أزرق", fr: "Bleu marine / Bleu" },
    sizes: [{ label: "12–18M", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "281.PNG"), img("5", "281.2.PNG"), img("5", "281.3.PNG")],
  },
  {
    id: "282",
    name: { en: "Baby Graphic Sweatshirt Set", ar: "Baby Graphic Sweatshirt Set", fr: "Baby Graphic Sweatshirt Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Brown", ar: "بني", fr: "Marron" },
      { en: "Dark Grey", ar: "غامق رمادي", fr: "Foncé Gris" },
    ],
    sizes: [{ label: "12–18M", qty: 1 }],
    originalPrice: 20.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "282.PNG"), img("5", "282.1.1.PNG"), img("5", "282.2.PNG"), img("5", "282.2.2.PNG"), img("5", "282.3.PNG"), img("5", "282.4.PNG"), img("5", "282.4.4.PNG"), img("5", "282.5.PNG"), img("5", "282.6.PNG")],
  },
  {
    id: "283",
    name: { en: "Women’s Floral Ruffle Sleeve Blouse", ar: "Women’s Floral Ruffle Sleeve Blouse", fr: "Women’s Floral Ruffle Sleeve Blouse" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "متعدد الألوان", fr: "Multicolore" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "283.PNG"), img("5", "283.2.PNG"), img("5", "283.3.PNG")],
  },
  {
    id: "284",
    name: { en: "3 Pairs Baby/Toddler Girls Tights", ar: "3 Pairs Baby/Toddler Girls Tights", fr: "3 Pairs Baby/Toddler Girls Tights" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Light Grey", ar: "فاتح رمادي", fr: "Clair Gris" },
      { en: "Dark Grey", ar: "غامق رمادي", fr: "Foncé Gris" },
      { en: "Black", ar: "أسود", fr: "Noir" },
    ],
    sizes: [{ label: "1-2 years", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "284.png")],
  },
  {
    id: "285",
    name: { en: "Women’s Military Style Colorblock Blazer", ar: "Women’s Military Style Colorblock Blazer", fr: "Women’s Military Style Colorblock Blazer" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Navy Blue", ar: "كحلي أزرق", fr: "Bleu marine Bleu" },
      { en: "Red", ar: "أحمر", fr: "Rouge" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
    ],
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 25.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "285.PNG"), img("5", "285.2.PNG"), img("5", "285.3.PNG")],
  },
  {
    id: "286",
    name: { en: "Women’s Burgundy Belted Shirt Blouse", ar: "Women’s Burgundy Belted Shirt Blouse", fr: "Women’s Burgundy Belted Shirt Blouse" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Burgundy", ar: "خمري", fr: "Bordeaux" },
    sizes: [{ label: "0XL", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "286.PNG"), img("5", "286.2.PNG"), img("5", "286.3.PNG")],
  },
  {
    id: "287",
    name: { en: "Older Kids 3pcs Burgundy Tracksuit Set", ar: "Older Kids 3pcs Burgundy Tracksuit Set", fr: "Older Kids 3pcs Burgundy Tracksuit Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Burgundy", ar: "خمري", fr: "Bordeaux" },
      { en: "White Striped", ar: "أبيض Striped", fr: "Blanc Striped" },
    ],
    sizes: [{ label: "12Y", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "287.PNG"), img("5", "287.2.PNG"), img("5", "287.3.PNG")],
  },
  {
    id: "288",
    name: { en: "Men’s Striped Short Sleeve Button-Up Shirt", ar: "Men’s Striped Short Sleeve Button-Up Shirt", fr: "Men’s Striped Short Sleeve Button-Up Shirt" },
    category: "shein",
    sheinCategory: "men",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Green", ar: "أخضر", fr: "Vert" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
    ],
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "288.PNG"), img("5", "288.2.PNG"), img("5", "288.3.PNG")],
  },
  {
    id: "289",
    name: { en: "Young Girls Pleated Knit Skirt", ar: "Young Girls Pleated Knit Skirt", fr: "Young Girls Pleated Knit Skirt" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Grey", ar: "رمادي", fr: "Gris" },
    sizes: [{ label: "4Y", qty: 1 }],
    originalPrice: 11.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "289.PNG"), img("5", "289.2.PNG"), img("5", "289.3.PNG")],
  },
  {
    id: "290",
    name: { en: "3pcs Toddler Girls Royal Blue Outfit Set", ar: "3pcs Toddler Girls Royal Blue Outfit Set", fr: "3pcs Toddler Girls Royal Blue Outfit Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Royal Blue", ar: "Royal أزرق", fr: "Royal Bleu" },
      { en: "Light Denim", ar: "فاتح Denim", fr: "Clair Denim" },
    ],
    sizes: [{ label: "6Y", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "290.PNG"), img("5", "290.2.PNG"), img("5", "290.3.PNG")],
  },
  {
    id: "291",
    name: { en: "Women’s Crochet Knit Cardigan", ar: "Women’s Crochet Knit Cardigan", fr: "Women’s Crochet Knit Cardigan" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Beige", ar: "بيج", fr: "Beige" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "291.PNG"), img("5", "291.2.PNG"), img("5", "291.3.PNG")],
  },
  {
    id: "292",
    name: { en: "Girls Bowknot Slip-On Shoes", ar: "Girls Bowknot Slip-On Shoes", fr: "Girls Bowknot Slip-On Shoes" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Blue", ar: "أزرق", fr: "Bleu" },
    sizes: [{ label: "EUR22", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "292.PNG")],
  },
  {
    id: "293",
    name: { en: "Baby Boys Paisley Hooded Jacket & Pants Set", ar: "Baby Boys Paisley Hooded Jacket & Pants Set", fr: "Baby Boys Paisley Hooded Jacket & Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "12–18M", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "293.png"), img("5", "293.2.PNG"), img("5", "293.3.PNG")],
  },
  {
    id: "294",
    name: { en: "Baby Boys Printed Shirt & Shorts Set", ar: "Baby Boys Printed Shirt & Shorts Set", fr: "Baby Boys Printed Shirt & Shorts Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Blue", ar: "أزرق", fr: "Bleu" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
    ],
    sizes: [{ label: "12–18M", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "294.PNG"), img("5", "294.2.PNG"), img("5", "294.3.PNG")],
  },
  {
    id: "295",
    name: { en: "Baby Boys Cartoon Sweatshirt & Denim Pants Set", ar: "Baby Boys Cartoon Sweatshirt & Denim Pants Set", fr: "Baby Boys Cartoon Sweatshirt & Denim Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "متعدد الألوان", fr: "Multicolore" },
    sizes: [{ label: "9–12M", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "295.PNG"), img("5", "295.2.PNG"), img("5", "295.3.PNG")],
  },
  {
    id: "296",
    name: { en: "Height Increase Shoe Insoles", ar: "Height Increase Shoe Insoles", fr: "Height Increase Shoe Insoles" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "4.5cm", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "296.PNG")],
  },
  {
    id: "297",
    name: { en: "Women’s Pink Satin Embroidered Nightgown Set", ar: "Women’s Pink Satin Embroidered Nightgown Set", fr: "Women’s Pink Satin Embroidered Nightgown Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Pink", ar: "وردي", fr: "Rose" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "297.PNG"), img("5", "297.2.PNG"), img("5", "297.3.PNG")],
  },
  {
    id: "298",
    name: { en: "Teen Boys Tokyo Graphic Print T-Shirt", ar: "Teen Boys Tokyo Graphic Print T-Shirt", fr: "Teen Boys Tokyo Graphic Print T-Shirt" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Dark Green", ar: "غامق / أخضر", fr: "Foncé / Vert" },
    sizes: [{ label: "14Y", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "298.PNG"), img("5", "298.2.PNG"), img("5", "298.3.PNG")],
  },
  {
    id: "299",
    name: { en: "EMERY ROSE Women’s Elegant Cinched Waist Wrap Coat", ar: "EMERY ROSE Women’s Elegant Cinched Waist Wrap Coat", fr: "EMERY ROSE Women’s Elegant Cinched Waist Wrap Coat" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Grey", ar: "رمادي", fr: "Gris" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 70.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "299.PNG"), img("5", "299.2.PNG"), img("5", "299.3.PNG")],
  },
  {
    id: "300",
    name: { en: "Kids 2pcs/Set Toddler Girls’ Vintage Plaid Shacket and Casual Jumpsuit", ar: "Kids 2pcs/Set Toddler Girls’ Vintage Plaid Shacket and Casual Jumpsuit", fr: "Kids 2pcs/Set Toddler Girls’ Vintage Plaid Shacket and Casual Jumpsuit" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "5Y", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "300.PNG"), img("5", "300.2.PNG"), img("5", "300.3.PNG")],
  },
  {
    id: "301",
    name: { en: "Elegant Solid Color Long Sleeve Wrap Front Bodysuit", ar: "Elegant Solid Color Long Sleeve Wrap Front Bodysuit", fr: "Elegant Solid Color Long Sleeve Wrap Front Bodysuit" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Olive Green", ar: "زيتوني أخضر", fr: "Olive Vert" },
      { en: "Army Green", ar: "Army أخضر", fr: "Army Vert" },
    ],
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "301.PNG"), img("5", "301.2.PNG"), img("5", "301.3.PNG")],
  },
  {
    id: "302",
    name: { en: "Baby Boy Letter Graphic Print T-Shirt & Vest With Shorts Set", ar: "Baby Boy Letter Graphic Print T-Shirt & Vest With Shorts Set", fr: "Baby Boy Letter Graphic Print T-Shirt & Vest With Shorts Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Brown", ar: "بني", fr: "Marron" },
      { en: "Tan", ar: "Tan", fr: "Tan" },
    ],
    sizes: [{ label: "12–18M", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "302.PNG"), img("5", "302.2.PNG"), img("5", "302.3.PNG")],
  },
  {
    id: "303",
    name: { en: "Insulated Lunch Bag / Cooler Bag", ar: "Insulated Lunch Bag / Cooler Bag", fr: "Insulated Lunch Bag / Cooler Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Navy Blue", ar: "كحلي / أزرق", fr: "Bleu marine / Bleu" },
    quantity: 1,
    originalPrice: 6.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "303.PNG")],
  },
  {
    id: "304",
    name: { en: "Women’s Mesh Pajama Set", ar: "Women’s Mesh Pajama Set", fr: "Women’s Mesh Pajama Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Red", ar: "أحمر", fr: "Rouge" },
      { en: "Black option shown on label", ar: "أسود option shown on label", fr: "Noir option shown on label" },
    ],
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "304.PNG"), img("5", "304.2.PNG"), img("5", "304.3.PNG")],
  },
  {
    id: "305",
    name: { en: "Women’s Lace Trim Crew Socks", ar: "Women’s Lace Trim Crew Socks", fr: "Women’s Lace Trim Crew Socks" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black & White", ar: "أسود / & / أبيض", fr: "Noir / & / Blanc" },
    sizes: [{ label: "36–39", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "305.PNG"), img("5", "305.2.PNG"), img("5", "305.3.PNG")],
  },
  {
    id: "306",
    name: { en: "Women’s V-Neck Shirt / Long Sleeve Top", ar: "Women’s V-Neck Shirt / Long Sleeve Top", fr: "Women’s V-Neck Shirt / Long Sleeve Top" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Baby Pink", ar: "baby / وردي", fr: "Baby / Rose" },
    sizes: [{ label: "XL", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "306.PNG"), img("5", "306.2.PNG"), img("5", "306.3.PNG")],
  },
  {
    id: "307",
    name: { en: "Women’s Button Shirt / Blouse", ar: "Women’s Button Shirt / Blouse", fr: "Women’s Button Shirt / Blouse" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Orange", ar: "برتقالي", fr: "Orange" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "307.PNG"), img("5", "307.2.PNG"), img("5", "307.3.PNG")],
  },
  {
    id: "308",
    name: { en: "Kids Girls 2pcs Outfit / Cherry Skirt Set", ar: "Kids Girls 2pcs Outfit / Cherry Skirt Set", fr: "Kids Girls 2pcs Outfit / Cherry Skirt Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Apricot", ar: "Apricot", fr: "Apricot" },
      { en: "Cream with Red checkered skirt", ar: "كريمي with أحمر checkered skirt", fr: "Crème with Rouge checkered skirt" },
    ],
    sizes: [{ label: "6Y", qty: 1 }],
    originalPrice: 17.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "308.jpg"), img("5", "308.2.jpg"), img("5", "308.3.jpg")],
  },
  {
    id: "309",
    name: { en: "Baby Girl Winter Dress / Knitted Sweater Dress", ar: "Baby Girl Winter Dress / Knitted Sweater Dress", fr: "Baby Girl Winter Dress / Knitted Sweater Dress" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Coffee Brown", ar: "بني قهوة / بني", fr: "Café / Marron" },
    sizes: [{ label: "9–12M", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "309.jpg"), img("5", "309.2.jpg"), img("5", "309.3.jpg")],
  },
  {
    id: "310",
    name: { en: "3pcs Baby Girl Denim Set / Cute Blue Outfit", ar: "3pcs Baby Girl Denim Set / Cute Blue Outfit", fr: "3pcs Baby Girl Denim Set / Cute Blue Outfit" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Blue", ar: "أزرق", fr: "Bleu" },
    sizes: [{ label: "9–12M", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "310.png"), img("5", "310.2.png"), img("5", "310.3.png")],
  },
  {
    id: "311",
    name: { en: "2pcs Baby Girl Outfit / Valentine Style Set", ar: "2pcs Baby Girl Outfit / Valentine Style Set", fr: "2pcs Baby Girl Outfit / Valentine Style Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Burgundy", ar: "خمري", fr: "Bordeaux" },
      { en: "White", ar: "أبيض", fr: "Blanc" },
    ],
    sizes: [{ label: "9–12M", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "311.png"), img("5", "311.2.png"), img("5", "311.3.png")],
  },
  {
    id: "312",
    name: { en: "Kids Puffer Vest / Sleeveless Jacket", ar: "Kids Puffer Vest / Sleeveless Jacket", fr: "Kids Puffer Vest / Sleeveless Jacket" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "9Y", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "312.png"), img("5", "312.2.png"), img("5", "312.3.png")],
  },
  {
    id: "313",
    name: { en: "Baby Girl Denim Outfit Set", ar: "Baby Girl Denim Outfit Set", fr: "Baby Girl Denim Outfit Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Blue", ar: "أزرق", fr: "Bleu" },
    sizes: [{ label: "12–18M", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "313.PNG"), img("5", "313.2.PNG"), img("5", "313.3.PNG")],
  },
  {
    id: "314",
    name: { en: "Girls Red Heart Cardigan & Dress Set", ar: "Girls Red Heart Cardigan & Dress Set", fr: "Girls Red Heart Cardigan & Dress Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Red and White", ar: "أحمر / and / أبيض", fr: "Rouge / And / Blanc" },
    sizes: [{ label: "9Y", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "314.PNG"), img("5", "314.2.PNG"), img("5", "314.3.PNG")],
  },
  {
    id: "315",
    name: { en: "White Baby/Kids Sneakers", ar: "White Baby/Kids Sneakers", fr: "White Baby/Kids Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "EUR20", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "315.PNG"), img("5", "315.2.PNG"), img("5", "315.3.PNG")],
  },
  {
    id: "316",
    name: { en: "Black Mini Bodycon Dress", ar: "Black Mini Bodycon Dress", fr: "Black Mini Bodycon Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "316.PNG"), img("5", "316.2.PNG"), img("5", "316.3.PNG")],
  },
  {
    id: "317",
    name: { en: "Baby Girls 2-Piece Outfit Set", ar: "Baby Girls 2-Piece Outfit Set", fr: "Baby Girls 2-Piece Outfit Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "Brown", ar: "بني", fr: "Marron" },
      { en: "Beige", ar: "بيج", fr: "Beige" },
    ],
    sizes: [{ label: "12–18M", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "317.PNG"), img("5", "317.2.PNG"), img("5", "317.3.PNG")],
  },
  {
    id: "318",
    name: { en: "Women’s Long Floral Skirt", ar: "Women’s Long Floral Skirt", fr: "Women’s Long Floral Skirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Red Floral", ar: "أحمر Floral", fr: "Rouge Floral" },
    ],
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "318.PNG"), img("5", "318.2.PNG"), img("5", "318.3.PNG")],
  },
  {
    id: "319",
    name: { en: "Women Black Graphic T-Shirt", ar: "Women Black Graphic T-Shirt", fr: "Women Black Graphic T-Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "319.PNG"), img("5", "319.2.PNG"), img("5", "319.3.PNG")],
  },
  {
    id: "320",
    name: { en: "Men’s Striped Shirt & Pants Set", ar: "Men’s Striped Shirt & Pants Set", fr: "Men’s Striped Shirt & Pants Set" },
    category: "shein",
    sheinCategory: "men",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Grey stripes with light beige pants", ar: "رمادي stripes with فاتح بيج pants", fr: "Gris stripes with Clair Beige pants" },
    ],
    sizes: [{ label: "large", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "320.PNG"), img("5", "320.2.PNG"), img("5", "320.3.PNG")],
  },
  {
    id: "321",
    name: { en: "Baby White Bow Tights", ar: "Baby White Bow Tights", fr: "Baby White Bow Tights" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: [{ label: "6–12M", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "321.PNG"), img("5", "321.2.PNG"), img("5", "321.3.PNG")],
  },
  {
    id: "322",
    name: { en: "Girls Pearl Butterfly Jewelry Set", ar: "Girls Pearl Butterfly Jewelry Set", fr: "Girls Pearl Butterfly Jewelry Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    colors: [
      { en: "White", ar: "أبيض", fr: "Blanc" },
      { en: "Gold", ar: "ذهبي", fr: "Doré" },
    ],
    sizes: [{ label: "4 pcs", qty: 1 }],
    originalPrice: 3.0,
    addedDate: "2026-06-02",
    tags: [],
    images: [img("5", "322.PNG")],
  },
  {
    id: "323",
    name: { en: "Infant Red Canvas Sneakers", ar: "Infant Red Canvas Sneakers", fr: "Infant Red Canvas Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Red", ar: "Red", fr: "Red" },
    sizes: [{ label: "EUR18", qty: 1 }],
    originalPrice: 8.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "323.png"), img("5b", "323.2.png"), img("5b", "323.3.png")],
  },
  {
    id: "324",
    name: { en: "Women’s Black Zip-Up Short Sleeve Swim Romper", ar: "Women’s Black Zip-Up Short Sleeve Swim Romper", fr: "Women’s Black Zip-Up Short Sleeve Swim Romper" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "Black", fr: "Black" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "324.png"), img("5b", "324.2.png"), img("5b", "324.3.png")],
  },
  {
    id: "325",
    name: { en: "Leopard Print Short Sleeve T-Shirt", ar: "Leopard Print Short Sleeve T-Shirt", fr: "Leopard Print Short Sleeve T-Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown Leopard Print", ar: "Brown Leopard Print", fr: "Brown Leopard Print" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "325.png"), img("5b", "325.2.png"), img("5b", "325.3.png")],
  },
  {
    id: "326",
    name: { en: "Women’s Coffee Wristlet Wallet", ar: "Women’s Coffee Wristlet Wallet", fr: "Women’s Coffee Wristlet Wallet" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Coffee", ar: "Coffee", fr: "Coffee" },
    sizes: [{ label: "Small Wallet", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "326.png"), img("5b", "326.2.png")],
  },
  {
    id: "327",
    name: { en: "Girls Oversized Hoodie Dress", ar: "Girls Oversized Hoodie Dress", fr: "Girls Oversized Hoodie Dress" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Lilac Purple", ar: "Lilac Purple", fr: "Lilac Purple" },
    sizes: [{ label: "4Y", qty: 1 }],
    originalPrice: 20.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "327.png"), img("5b", "327.2.png"), img("5b", "327.3.png")],
  },
  {
    id: "328",
    name: { en: "Square Neck Long Sleeve Top", ar: "Square Neck Long Sleeve Top", fr: "Square Neck Long Sleeve Top" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black/white", ar: "Black/white", fr: "Black/white" },
    sizes: [{ label: "XL", qty: 1 }],
    originalPrice: 8.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "328.png"), img("5b", "328.2.png"), img("5b", "328.3.png")],
  },
  {
    id: "329",
    name: { en: "White Long Sleeve Button-Up Shirt", ar: "White Long Sleeve Button-Up Shirt", fr: "White Long Sleeve Button-Up Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    sizes: [{ label: "M/l", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "329.png"), img("5b", "329.2.png"), img("5b", "329.3.png")],
  },
  {
    id: "330",
    name: { en: "Women’s Cream Wool Beret", ar: "Women’s Cream Wool Beret", fr: "Women’s Cream Wool Beret" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    color: { en: "Cream / White", ar: "Cream / White", fr: "Cream / White" },
    quantity: 1,
    originalPrice: 5.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "330.png"), img("5b", "330.2.png"), img("5b", "330.3.png")],
  },
  {
    id: "331",
    name: { en: "6pcs Black Satin Sleep Set", ar: "6pcs Black Satin Sleep Set", fr: "6pcs Black Satin Sleep Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "Black", fr: "Black" },
    quantity: 1,
    originalPrice: 5.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "331.png")],
  },
  {
    id: "332",
    name: { en: "Women’s White Platform Sneakers with Pearl Chain", ar: "Women’s White Platform Sneakers with Pearl Chain", fr: "Women’s White Platform Sneakers with Pearl Chain" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    sizes: [{ label: "CN37", qty: 1 }],
    originalPrice: 20.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "332.png"), img("5b", "332.2.png"), img("5b", "332.3.png")],
  },
  {
    id: "333",
    name: { en: "Maternity Striped Nursing Bra", ar: "Maternity Striped Nursing Bra", fr: "Maternity Striped Nursing Bra" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "Brown", fr: "Brown" },
    sizes: [{ label: "XL", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "333.png"), img("5b", "333.2.png"), img("5b", "333.3.png")],
  },
  {
    id: "334",
    name: { en: "Girls Black & White Plaid Layered Dress", ar: "Girls Black & White Plaid Layered Dress", fr: "Girls Black & White Plaid Layered Dress" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Black and White", ar: "Black and White", fr: "Black and White" },
    sizes: [{ label: "6Y", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "334.png"), img("5b", "334.2.png"), img("5b", "334.3.png")],
  },
  {
    id: "335",
    name: { en: "Kids Beige Chunky Sports Sneakers", ar: "Kids Beige Chunky Sports Sneakers", fr: "Kids Beige Chunky Sports Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Beige / Cream", ar: "Beige / Cream", fr: "Beige / Cream" },
    sizes: [{ label: "EUR27", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "335.png"), img("5b", "335.2.png")],
  },
  {
    id: "336",
    name: { en: "6pcs Egg Shape Puzzle Learning Toy Set", ar: "6pcs Egg Shape Puzzle Learning Toy Set", fr: "6pcs Egg Shape Puzzle Learning Toy Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 6.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "336.png"), img("5b", "336.2.png")],
  },
  {
    id: "337",
    name: { en: "Pink Bow & Pearl Phone Case", ar: "Pink Bow & Pearl Phone Case", fr: "Pink Bow & Pearl Phone Case" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Pink", ar: "Pink", fr: "Pink" },
    quantity: 1,
    originalPrice: 4.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "337.png")],
  },
  {
    id: "338",
    name: { en: "Pink Cherry Bow Phone Case", ar: "Pink Cherry Bow Phone Case", fr: "Pink Cherry Bow Phone Case" },
    category: "shein",
    sheinCategory: "phone_accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Pink", ar: "Pink", fr: "Pink" },
    quantity: 1,
    originalPrice: 4.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "338.png")],
  },
  {
    id: "339",
    name: { en: "Black Scalp Massager Shampoo Brush", ar: "Black Scalp Massager Shampoo Brush", fr: "Black Scalp Massager Shampoo Brush" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "Black", fr: "Black" },
    quantity: 1,
    originalPrice: 2.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "339.png"), img("5b", "339.2.JPG")],
  },
  {
    id: "340",
    name: { en: "Black Velvet French Bow Hair Clip", ar: "Black Velvet French Bow Hair Clip", fr: "Black Velvet French Bow Hair Clip" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "Black", fr: "Black" },
    quantity: 1,
    originalPrice: 1.5,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "340.png"), img("5b", "340.2.JPG")],
  },
  {
    id: "341",
    name: { en: "Boys Grey Shirt & Pants Set", ar: "Boys Grey Shirt & Pants Set", fr: "Boys Grey Shirt & Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Grey", ar: "Grey", fr: "Grey" },
    sizes: [{ label: "9Y", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "341.png"), img("5b", "341.2.png"), img("5b", "341.3.png")],
  },
  {
    id: "342",
    name: { en: "Men’s Dark Grey Straight Leg Jeans", ar: "Men’s Dark Grey Straight Leg Jeans", fr: "Men’s Dark Grey Straight Leg Jeans" },
    category: "shein",
    sheinCategory: "men",
    authentic: false,
    discountPct: 30,
    color: { en: "Dark Grey", ar: "Dark Grey", fr: "Dark Grey" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 17.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "342.png"), img("5b", "342.2.png"), img("5b", "342.3.png")],
  },
  {
    id: "343",
    name: { en: "Women’s Multicolor Portrait Print V-Neck Shirt", ar: "Women’s Multicolor Portrait Print V-Neck Shirt", fr: "Women’s Multicolor Portrait Print V-Neck Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "343.png"), img("5b", "343.2.png"), img("5b", "343.3.png")],
  },
  {
    id: "344",
    name: { en: "Women’s Blue Denim Button-Up Shirt", ar: "Women’s Blue Denim Button-Up Shirt", fr: "Women’s Blue Denim Button-Up Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Medium Blue", ar: "Medium Blue", fr: "Medium Blue" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "344.png"), img("5b", "344.2.png"), img("5b", "344.3.png")],
  },
  {
    id: "345",
    name: { en: "Kids Striped Heart Hoodie", ar: "Kids Striped Heart Hoodie", fr: "Kids Striped Heart Hoodie" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "White / Black Stripes", ar: "White / Black Stripes", fr: "White / Black Stripes" },
    sizes: [{ label: "4Y", qty: 1 }],
    originalPrice: 9.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "345.png"), img("5b", "345.2.png"), img("5b", "345.3.png")],
  },
  {
    id: "346",
    name: { en: "Girls White Lace Collar Blouse", ar: "Girls White Lace Collar Blouse", fr: "Girls White Lace Collar Blouse" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    sizes: [{ label: "4Y", qty: 1 }],
    originalPrice: 8.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "346.png"), img("5b", "346.2.png"), img("5b", "346.3.png")],
  },
  {
    id: "347",
    name: { en: "Women’s Beige Platform Sneakers", ar: "Women’s Beige Platform Sneakers", fr: "Women’s Beige Platform Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Beige / Cream", ar: "Beige / Cream", fr: "Beige / Cream" },
    sizes: [{ label: "CN39", qty: 1 }],
    originalPrice: 20.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "347.png"), img("5b", "347.2.png"), img("5b", "347.3.png")],
  },
  {
    id: "348",
    name: { en: "Kids Blue Hook & Loop Sneakers", ar: "Kids Blue Hook & Loop Sneakers", fr: "Kids Blue Hook & Loop Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Blue", ar: "Blue", fr: "Blue" },
    sizes: [{ label: "EUR28", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "348.png"), img("5b", "348.2.png"), img("5b", "348.3.png")],
  },
  {
    id: "349",
    name: { en: "Women’s Black Straight Leg Jeans", ar: "Women’s Black Straight Leg Jeans", fr: "Women’s Black Straight Leg Jeans" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "Black", fr: "Black" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "349.png"), img("5b", "349.2.png"), img("5b", "349.3.png")],
  },
  {
    id: "350",
    name: { en: "Navy Blue Ribbed Button Front Long Sleeve Top", ar: "Navy Blue Ribbed Button Front Long Sleeve Top", fr: "Navy Blue Ribbed Button Front Long Sleeve Top" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Navy Blue", ar: "Navy Blue", fr: "Navy Blue" },
    sizes: [{ label: "XL", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "350.png"), img("5b", "350.2.png"), img("5b", "350.3.png")],
  },
  {
    id: "351",
    name: { en: "Girls Yellow Floral Vintage Dress", ar: "Girls Yellow Floral Vintage Dress", fr: "Girls Yellow Floral Vintage Dress" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Yellow", ar: "Yellow", fr: "Yellow" },
    sizes: [{ label: "4Y", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "351.png"), img("5b", "351.2.png"), img("5b", "351.3.png")],
  },
  {
    id: "352",
    name: { en: "Girls Plaid Floral Long Sleeve Dress", ar: "Girls Plaid Floral Long Sleeve Dress", fr: "Girls Plaid Floral Long Sleeve Dress" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "4Y", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "352.png"), img("5b", "352.2.png"), img("5b", "352.3.png")],
  },
  {
    id: "353",
    name: { en: "Girls Burgundy Sweatshirt & Jogger Pants Set", ar: "Girls Burgundy Sweatshirt & Jogger Pants Set", fr: "Girls Burgundy Sweatshirt & Jogger Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Burgundy", ar: "Burgundy", fr: "Burgundy" },
    sizes: [{ label: "4Y", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "353.png"), img("5b", "353.2.png"), img("5b", "353.3.png")],
  },
  {
    id: "354",
    name: { en: "Large Foldable Clothes Storage Bag", ar: "Large Foldable Clothes Storage Bag", fr: "Large Foldable Clothes Storage Bag" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Grey / Transparent", ar: "Grey / Transparent", fr: "Grey / Transparent" },
    sizes: [{ label: "Large", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "354.png"), img("5b", "354.2.JPG")],
  },
  {
    id: "355",
    name: { en: "Women’s Multicolor Floral Maxi Dress", ar: "Women’s Multicolor Floral Maxi Dress", fr: "Women’s Multicolor Floral Maxi Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "355.png"), img("5b", "355.2.png"), img("5b", "355.3.png")],
  },
  {
    id: "356",
    name: { en: "Women’s White Floral Button-Up Shirt", ar: "Women’s White Floral Button-Up Shirt", fr: "Women’s White Floral Button-Up Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor / Floral print", ar: "Multicolor / Floral print", fr: "Multicolor / Floral print" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "356.png"), img("5b", "356.2.png"), img("5b", "356.3.png")],
  },
  {
    id: "357",
    name: { en: "Black Slip-On Baby Boy Shoes", ar: "Black Slip-On Baby Boy Shoes", fr: "Black Slip-On Baby Boy Shoes" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "Black", fr: "Black" },
    sizes: [{ label: "EUR 23", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "357.png"), img("5b", "357.2.png"), img("5b", "357.3.png")],
  },
  {
    id: "358",
    name: { en: "Kids Heart Pattern Tights", ar: "Kids Heart Pattern Tights", fr: "Kids Heart Pattern Tights" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "beige-black", ar: "beige-black", fr: "beige-black" },
    sizes: [{ label: "4–7Y", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "358.png"), img("5b", "358.2.png"), img("5b", "358.3.png")],
  },
  {
    id: "359",
    name: { en: "Women’s Black & Gold Shirt Dress", ar: "Women’s Black & Gold Shirt Dress", fr: "Women’s Black & Gold Shirt Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black and Gold", ar: "Black and Gold", fr: "Black and Gold" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "359.png"), img("5b", "359.2.png"), img("5b", "359.3.png")],
  },
  {
    id: "360",
    name: { en: "Men’s Casual Sports Jogger Pants", ar: "Men’s Casual Sports Jogger Pants", fr: "Men’s Casual Sports Jogger Pants" },
    category: "shein",
    sheinCategory: "men",
    authentic: false,
    discountPct: 30,
    color: { en: "Light Gray", ar: "Light Gray", fr: "Light Gray" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "360.png"), img("5b", "360.2.png"), img("5b", "360.3.png")],
  },
  {
    id: "361",
    name: { en: "Toddler Casual Solid Color Elastic Waist Pants, Suitable For Outdoor Wear In Spring And Autumn", ar: "Toddler Casual Solid Color Elastic Waist Pants, Suitable For Outdoor Wear In Spring And Autumn", fr: "Toddler Casual Solid Color Elastic Waist Pants, Suitable For Outdoor Wear In Spring And Autumn" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Army Green", ar: "Army Green", fr: "Army Green" },
    sizes: [{ label: "7Y", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "361.png"), img("5b", "361.2.png"), img("5b", "361.3.png")],
  },
  {
    id: "362",
    name: { en: "Baby Boys Formal 4pcs Outfit Set with Bodysuit, Bow Tie, Vest and Pants", ar: "Baby Boys Formal 4pcs Outfit Set with Bodysuit, Bow Tie, Vest and Pants", fr: "Baby Boys Formal 4pcs Outfit Set with Bodysuit, Bow Tie, Vest and Pants" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "White and Blue", ar: "White and Blue", fr: "White and Blue" },
    sizes: [{ label: "1-3M", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "362.png"), img("5b", "362.2.png"), img("5b", "362.3.png")],
  },
  {
    id: "363",
    name: { en: "Newborn Baby Girls’ Autumn/winter Cute & Comfy Pink Footed Jumpsuit With Snap Button, Headband And Ruffle Detail", ar: "Newborn Baby Girls’ Autumn/winter Cute & Comfy Pink Footed Jumpsuit With Snap Button, Headband And Ruffle Detail", fr: "Newborn Baby Girls’ Autumn/winter Cute & Comfy Pink Footed Jumpsuit With Snap Button, Headband And Ruffle Detail" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Dusty Pink", ar: "Dusty Pink", fr: "Dusty Pink" },
    sizes: [{ label: "3-6M", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "363.png"), img("5b", "363.2.png"), img("5b", "363.3.png")],
  },
  {
    id: "364",
    name: { en: "Spring/Autumn New Girls’ Leather Shoes, Embroidered Bow Decor Girls’ Soft Bottom Shoes", ar: "Spring/Autumn New Girls’ Leather Shoes, Embroidered Bow Decor Girls’ Soft Bottom Shoes", fr: "Spring/Autumn New Girls’ Leather Shoes, Embroidered Bow Decor Girls’ Soft Bottom Shoes" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    sizes: [{ label: "EUR27", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "364.png"), img("5b", "364.2.png"), img("5b", "364.3.png")],
  },
  {
    id: "365",
    name: { en: "Women’s Leopard Print Button Front Shirt", ar: "Women’s Leopard Print Button Front Shirt", fr: "Women’s Leopard Print Button Front Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Green", ar: "Green", fr: "Green" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "365.png"), img("5b", "365.2.png"), img("5b", "365.3.png")],
  },
  {
    id: "366",
    name: { en: "Men’s Prayer Cap, Embroidered Islamic Beanie Hat, Suitable For Daily Prayer", ar: "Men’s Prayer Cap, Embroidered Islamic Beanie Hat, Suitable For Daily Prayer", fr: "Men’s Prayer Cap, Embroidered Islamic Beanie Hat, Suitable For Daily Prayer" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    quantity: 1,
    originalPrice: 2.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "366.png")],
  },
  {
    id: "367",
    name: { en: "Men’s Casual Minimalist Mountain Printed Short Sleeve T-Shirt", ar: "Men’s Casual Minimalist Mountain Printed Short Sleeve T-Shirt", fr: "Men’s Casual Minimalist Mountain Printed Short Sleeve T-Shirt" },
    category: "shein",
    sheinCategory: "men",
    authentic: false,
    discountPct: 30,
    color: { en: "Mint Green", ar: "Mint Green", fr: "Mint Green" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "367.png"), img("5b", "367.2.png"), img("5b", "367.3.png")],
  },
  {
    id: "368",
    name: { en: "Casual Cute Yellow Girl Graphic Women Shirt, Suitable For Summer", ar: "Casual Cute Yellow Girl Graphic Women Shirt, Suitable For Summer", fr: "Casual Cute Yellow Girl Graphic Women Shirt, Suitable For Summer" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "368.png"), img("5b", "368.2.png"), img("5b", "368.3.png")],
  },
  {
    id: "369",
    name: { en: "Women’s Shoes, 2025 Spring/Autumn New Thick Sole Versatile Chunky Sneakers", ar: "Women’s Shoes, 2025 Spring/Autumn New Thick Sole Versatile Chunky Sneakers", fr: "Women’s Shoes, 2025 Spring/Autumn New Thick Sole Versatile Chunky Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "white", ar: "white", fr: "white" },
    sizes: [{ label: "CN39", qty: 1 }],
    originalPrice: 18.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("5b", "369.png"), img("5b", "369.2.png")],
  },
  {
    id: "370",
    name: { en: "Women’s Casual Sleeveless Top, Tank Top Suitable For Spring", ar: "Women’s Casual Sleeveless Top, Tank Top Suitable For Spring", fr: "Women’s Casual Sleeveless Top, Tank Top Suitable For Spring" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black-white", ar: "Black-white", fr: "Black-white" },
    sizes: [{ label: "l", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "370.png"), img("6", "370.1.1.png"), img("6", "370.2.png"), img("6", "370.3.png"), img("6", "370.4.png"), img("6", "370.5.png")],
  },
  {
    id: "371",
    name: { en: "Women Wide Leg Denim Jeans", ar: "Women Wide Leg Denim Jeans", fr: "Women Wide Leg Denim Jeans" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Dark Blue", ar: "Dark Blue", fr: "Dark Blue" },
    sizes: [{ label: "28", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "371.png"), img("6", "371.2.png"), img("6", "371.3.png")],
  },
  {
    id: "372",
    name: { en: "Women’s Casual Everyday Commute Versatile Solid Color Drop Shoulder Blouse", ar: "Women’s Casual Everyday Commute Versatile Solid Color Drop Shoulder Blouse", fr: "Women’s Casual Everyday Commute Versatile Solid Color Drop Shoulder Blouse" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Dark Green", ar: "Dark Green", fr: "Dark Green" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "372.png"), img("6", "372.2.png"), img("6", "372.3.png")],
  },
  {
    id: "373",
    name: { en: "Kids Young Girl Washed Casual Loose Cute Denim Jeans", ar: "Kids Young Girl Washed Casual Loose Cute Denim Jeans", fr: "Kids Young Girl Washed Casual Loose Cute Denim Jeans" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Blue", ar: "Blue", fr: "Blue" },
    sizes: [{ label: "4Y", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "373.png"), img("6", "373.2.png"), img("6", "373.3.png")],
  },
  {
    id: "374",
    name: { en: "Baby Girl Contrast Lace Flounce Sleeve Mesh Overlay Bodysuit & Headband", ar: "Baby Girl Contrast Lace Flounce Sleeve Mesh Overlay Bodysuit & Headband", fr: "Baby Girl Contrast Lace Flounce Sleeve Mesh Overlay Bodysuit & Headband" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Pink", ar: "Pink", fr: "Pink" },
    sizes: [{ label: "3-6M", qty: 1 }],
    originalPrice: 11.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "374.png"), img("6", "374.2.png"), img("6", "374.3.png")],
  },
  {
    id: "375",
    name: { en: "Tween Girls Casual Printed Pullover Sweatshirt, Thermal Lined", ar: "Tween Girls Casual Printed Pullover Sweatshirt, Thermal Lined", fr: "Tween Girls Casual Printed Pullover Sweatshirt, Thermal Lined" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Apricot", ar: "Apricot", fr: "Apricot" },
    sizes: [{ label: "4Y", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "375.png"), img("6", "375.2.png"), img("6", "375.3.png")],
  },
  {
    id: "376",
    name: { en: "Young Girl Loose Fit Casual Comfortable Cherry Pattern Sweatshirt, Autumn/Winter", ar: "Young Girl Loose Fit Casual Comfortable Cherry Pattern Sweatshirt, Autumn/Winter", fr: "Young Girl Loose Fit Casual Comfortable Cherry Pattern Sweatshirt, Autumn/Winter" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "White Cherry Pattern", ar: "White Cherry Pattern", fr: "White Cherry Pattern" },
    sizes: [{ label: "4Y", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "376.png"), img("6", "376.2.png"), img("6", "376.3.png")],
  },
  {
    id: "377",
    name: { en: "5 Pairs Women’s Striped Pattern Breathable Fashion Ankle Socks, Suitable For Daily Wear", ar: "5 Pairs Women’s Striped Pattern Breathable Fashion Ankle Socks, Suitable For Daily Wear", fr: "5 Pairs Women’s Striped Pattern Breathable Fashion Ankle Socks, Suitable For Daily Wear" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "36-39", qty: 1 }],
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "377.png"), img("6", "377.2.png")],
  },
  {
    id: "378",
    name: { en: "100pcs Transparent Food Preservation Cover, Multi Use Elastic Dustproof Disposable Bags", ar: "100pcs Transparent Food Preservation Cover, Multi Use Elastic Dustproof Disposable Bags", fr: "100pcs Transparent Food Preservation Cover, Multi Use Elastic Dustproof Disposable Bags" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Transparent", ar: "Transparent", fr: "Transparent" },
    quantity: 1,
    originalPrice: 2.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "378.png")],
  },
  {
    id: "379",
    name: { en: "3pcs Women’s Sweet Pastoral Style Mesh, Embroidered & Printed Wide-Brim Headband", ar: "3pcs Women’s Sweet Pastoral Style Mesh, Embroidered & Printed Wide-Brim Headband", fr: "3pcs Women’s Sweet Pastoral Style Mesh, Embroidered & Printed Wide-Brim Headband" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "beige", ar: "beige", fr: "beige" },
    quantity: 1,
    originalPrice: 5.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "379.png"), img("6", "379.2.png")],
  },
  {
    id: "380",
    name: { en: "1 Piece Waterproof Silicone Bra,", ar: "1 Piece Waterproof Silicone Bra,", fr: "1 Piece Waterproof Silicone Bra," },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Pink", ar: "Pink", fr: "Pink" },
    sizes: [{ label: "C", qty: 1 }],
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "380.png"), img("6", "380.2.png")],
  },
  {
    id: "381",
    name: { en: "4pcs Pure Cotton High Waist Comfortable Ribbed Solid Color Women’s Briefs", ar: "4pcs Pure Cotton High Waist Comfortable Ribbed Solid Color Women’s Briefs", fr: "4pcs Pure Cotton High Waist Comfortable Ribbed Solid Color Women’s Briefs" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "381.png"), img("6", "381.2.png"), img("6", "381.3.png")],
  },
  {
    id: "382",
    name: { en: "1pair Women’s Stylish & Sexy High-waisted Fishnet Pantyhose With Anti-hook Technology", ar: "1pair Women’s Stylish & Sexy High-waisted Fishnet Pantyhose With Anti-hook Technology", fr: "1pair Women’s Stylish & Sexy High-waisted Fishnet Pantyhose With Anti-hook Technology" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "Black", fr: "Black" },
    sizes: [{ label: "L-XXL", qty: 1 }],
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "382.png"), img("6", "382.2.png"), img("6", "382.3.png")],
  },
  {
    id: "383",
    name: { en: "8pcs Flower Hair Clips With Rhinestone Decor", ar: "8pcs Flower Hair Clips With Rhinestone Decor", fr: "8pcs Flower Hair Clips With Rhinestone Decor" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    quantity: 1,
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "383.png"), img("6", "383.2.png")],
  },
  {
    id: "384",
    name: { en: "Rainbow Rotating Tower Baby Stacking Toy", ar: "Rainbow Rotating Tower Baby Stacking Toy", fr: "Rainbow Rotating Tower Baby Stacking Toy" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "31.5 cm height", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "384.png"), img("6", "384.2.png")],
  },
  {
    id: "385",
    name: { en: "Unisex Printed Ski Mask Balaclava, UV Protection Windproof Face Mask Neck Gaiter", ar: "Unisex Printed Ski Mask Balaclava, UV Protection Windproof Face Mask Neck Gaiter", fr: "Unisex Printed Ski Mask Balaclava, UV Protection Windproof Face Mask Neck Gaiter" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "Black", fr: "Black" },
    quantity: 1,
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "385.png"), img("6", "385.2.png")],
  },
  {
    id: "386",
    name: { en: "2 Set Stainless Steel Bathroom Accessories, Thickened Towel Bar With Towel Ring / Wall Hooks", ar: "2 Set Stainless Steel Bathroom Accessories, Thickened Towel Bar With Towel Ring / Wall Hooks", fr: "2 Set Stainless Steel Bathroom Accessories, Thickened Towel Bar With Towel Ring / Wall Hooks" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Silver", ar: "Silver", fr: "Silver" },
    quantity: 1,
    originalPrice: 4.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "386.png"), img("6", "386.2.png")],
  },
  {
    id: "387",
    name: { en: "4pcs Girls Bow Decor Cable Knit Knee High Socks", ar: "4pcs Girls Bow Decor Cable Knit Knee High Socks", fr: "4pcs Girls Bow Decor Cable Knit Knee High Socks" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    quantity: 1,
    originalPrice: 5.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "387.png"), img("6", "387.2.png"), img("6", "387.3.png")],
  },
  {
    id: "388",
    name: { en: "4pcs Medium Size Black, White, Brown, Khaki Square Lightweight Plastic Hair Claw Clips", ar: "4pcs Medium Size Black, White, Brown, Khaki Square Lightweight Plastic Hair Claw Clips", fr: "4pcs Medium Size Black, White, Brown, Khaki Square Lightweight Plastic Hair Claw Clips" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Black, White, Brown, Khaki", ar: "Black, White, Brown, Khaki", fr: "Black, White, Brown, Khaki" },
    quantity: 1,
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "388.png"), img("6", "388.2.png")],
  },
  {
    id: "389",
    name: { en: "1 piece  Adjustable Jump Rope Suitable For Gym Workout, Fast Jumping Rope -For Aerobic Exercise,", ar: "1 piece  Adjustable Jump Rope Suitable For Gym Workout, Fast Jumping Rope -For Aerobic Exercise,", fr: "1 piece  Adjustable Jump Rope Suitable For Gym Workout, Fast Jumping Rope -For Aerobic Exercise," },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "pink", ar: "pink", fr: "pink" },
    quantity: 1,
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "389.png"), img("6", "389.2.png")],
  },
  {
    id: "390",
    name: { en: "75g Styling Wax Stick, Suitable For Controlling Frizzy And Unruly Edges Of Hair", ar: "75g Styling Wax Stick, Suitable For Controlling Frizzy And Unruly Edges Of Hair", fr: "75g Styling Wax Stick, Suitable For Controlling Frizzy And Unruly Edges Of Hair" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    sizes: [{ label: "75g", qty: 1 }],
    originalPrice: 4.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "390.png"), img("6", "390.2.png")],
  },
  {
    id: "391",
    name: { en: "1pc Reusable Silicone Hair Dye Cap With Hook, Professional & Practical Hair Dyeing Cap", ar: "1pc Reusable Silicone Hair Dye Cap With Hook, Professional & Practical Hair Dyeing Cap", fr: "1pc Reusable Silicone Hair Dye Cap With Hook, Professional & Practical Hair Dyeing Cap" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "391.png"), img("6", "391.2.png")],
  },
  {
    id: "392",
    name: { en: "2026 New Khaki Galaxy Dream Nail Polish, 1 Bottle/10ml, No Baking, Quick Drying", ar: "2026 New Khaki Galaxy Dream Nail Polish, 1 Bottle/10ml, No Baking, Quick Drying", fr: "2026 New Khaki Galaxy Dream Nail Polish, 1 Bottle/10ml, No Baking, Quick Drying" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "Brown", fr: "Brown" },
    sizes: [{ label: "10ml", qty: 1 }],
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "392.png")],
  },
  {
    id: "393",
    name: { en: "SHAKA Gel Nail Polish", ar: "SHAKA Gel Nail Polish", fr: "SHAKA Gel Nail Polish" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    color: { en: "Peach Red", ar: "Peach Red", fr: "Peach Red" },
    sizes: [{ label: "10ml", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "393.png")],
  },
  {
    id: "394",
    name: { en: "Press On Nails", ar: "Press On Nails", fr: "Press On Nails" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    color: { en: "Grey", ar: "Grey", fr: "Grey" },
    sizes: [{ label: "18–24M", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "394.png")],
  },
  {
    id: "395",
    name: { en: "Baby Girl Grey Flower Applique Straight Leg Jeans", ar: "Baby Girl Grey Flower Applique Straight Leg Jeans", fr: "Baby Girl Grey Flower Applique Straight Leg Jeans" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Grey", ar: "Grey", fr: "Grey" },
    sizes: [{ label: "18–24M", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "395.png"), img("6", "395.2.png"), img("6", "395.3.png")],
  },
  {
    id: "396",
    name: { en: "Young Boys Black & White Striped Half-Zip Sweatshirt", ar: "Young Boys Black & White Striped Half-Zip Sweatshirt", fr: "Young Boys Black & White Striped Half-Zip Sweatshirt" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Black & White", ar: "Black & White", fr: "Black & White" },
    sizes: [{ label: "7Y", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "396.png"), img("6", "396.2.png"), img("6", "396.3.png")],
  },
  {
    id: "397",
    name: { en: "2pcs Baby Girl Baby Pink Thermal Lined Warm Outfit", ar: "2pcs Baby Girl Baby Pink Thermal Lined Warm Outfit", fr: "2pcs Baby Girl Baby Pink Thermal Lined Warm Outfit" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Baby Pink", ar: "Baby Pink", fr: "Baby Pink" },
    sizes: [{ label: "18–24M", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "397.png"), img("6", "397.29.png"), img("6", "397.3.png")],
  },
  {
    id: "398",
    name: { en: "White Pleated Maxi Skirt", ar: "White Pleated Maxi Skirt", fr: "White Pleated Maxi Skirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "398.png"), img("6", "398.2.png"), img("6", "398.3.png")],
  },
  {
    id: "399",
    name: { en: "Baby Girl Red Lace Patchwork Long Sleeve Romper Dress Set", ar: "Baby Girl Red Lace Patchwork Long Sleeve Romper Dress Set", fr: "Baby Girl Red Lace Patchwork Long Sleeve Romper Dress Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Red", ar: "Red", fr: "Red" },
    sizes: [{ label: "6–9M", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "399.PNG"), img("6", "399.2.PNG"), img("6", "399.3.PNG")],
  },
  {
    id: "400",
    name: { en: "Women 3pcs Spaghetti Strap Cami Tank Top Set", ar: "Women 3pcs Spaghetti Strap Cami Tank Top Set", fr: "Women 3pcs Spaghetti Strap Cami Tank Top Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White / Khaki / Black", ar: "White / Khaki / Black", fr: "White / Khaki / Black" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "400.png"), img("6", "400.2.png"), img("6", "400.3.png")],
  },
  {
    id: "401",
    name: { en: "Men’s White Leather Casual Sneakers", ar: "Men’s White Leather Casual Sneakers", fr: "Men’s White Leather Casual Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "White & Black", ar: "White & Black", fr: "White & Black" },
    sizes: [{ label: "EU 39", qty: 1 }],
    originalPrice: 20.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "401.png")],
  },
  {
    id: "402",
    name: { en: "Women Sky Blue Off Shoulder Flared Sleeve Top", ar: "Women Sky Blue Off Shoulder Flared Sleeve Top", fr: "Women Sky Blue Off Shoulder Flared Sleeve Top" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Sky Blue", ar: "Sky Blue", fr: "Sky Blue" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "402.png"), img("6", "402.2.png"), img("6", "402.3.png")],
  },
  {
    id: "403",
    name: { en: "3pcs Toddler Denim Pants Set", ar: "3pcs Toddler Denim Pants Set", fr: "3pcs Toddler Denim Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "12–18M", qty: 1 }],
    originalPrice: 11.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "403.png"), img("6", "403.2.png"), img("6", "403.3.png")],
  },
  {
    id: "404",
    name: { en: "Kids New York Hoodie & Cargo Pants Set", ar: "Kids New York Hoodie & Cargo Pants Set", fr: "Kids New York Hoodie & Cargo Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "White & Black", ar: "White & Black", fr: "White & Black" },
    sizes: [{ label: "4Y", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "404.png"), img("6", "404.2.png"), img("6", "404.3.png")],
  },
  {
    id: "405",
    name: { en: "Men Black Graphic Hoodie", ar: "Men Black Graphic Hoodie", fr: "Men Black Graphic Hoodie" },
    category: "shein",
    sheinCategory: "men",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "Black", fr: "Black" },
    sizes: [{ label: "15Y", qty: 1 }],
    originalPrice: 22.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "405.PNG"), img("6", "405.2.PNG"), img("6", "405.3.PNG")],
  },
  {
    id: "406",
    name: { en: "Toddler Anti-Slip Soft Sole Shoes", ar: "Toddler Anti-Slip Soft Sole Shoes", fr: "Toddler Anti-Slip Soft Sole Shoes" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Blue", ar: "Blue", fr: "Blue" },
    sizes: [{ label: "0-3 months", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "406.png"), img("6", "406.2.png")],
  },
  {
    id: "407",
    name: { en: "Boy beige Casual Pants", ar: "Boy beige Casual Pants", fr: "Boy beige Casual Pants" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Khaki", ar: "Khaki", fr: "Khaki" },
    sizes: [{ label: "7Y", qty: 1 }],
    originalPrice: 8.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "407.png"), img("6", "407.2.png"), img("6", "407.3.png")],
  },
  {
    id: "408",
    name: { en: "Baby Boy Green Collared Top & Pants Set", ar: "Baby Boy Green Collared Top & Pants Set", fr: "Baby Boy Green Collared Top & Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "mint green", ar: "mint green", fr: "mint green" },
    sizes: [{ label: "2–3Y", qty: 1 }],
    originalPrice: 10.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "408.png"), img("6", "408.2.png"), img("6", "408.3.png")],
  },
  {
    id: "409",
    name: { en: "Girls White & Red Flower Dress", ar: "Girls White & Red Flower Dress", fr: "Girls White & Red Flower Dress" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Red Wood", ar: "Red Wood", fr: "Red Wood" },
    sizes: [{ label: "9Y", qty: 1 }],
    originalPrice: 20.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "409.png"), img("6", "409.2.png"), img("6", "409.3.png")],
  },
  {
    id: "410",
    name: { en: "Baby Boys Burgundy Milano Tracksuit Set", ar: "Baby Boys Burgundy Milano Tracksuit Set", fr: "Baby Boys Burgundy Milano Tracksuit Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Burgundy", ar: "Burgundy", fr: "Burgundy" },
    sizes: [{ label: "18–24M", qty: 1 }],
    originalPrice: 11.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "410.PNG"), img("6", "410.2.png"), img("6", "410.3.PNG")],
  },
  {
    id: "411",
    name: { en: "Women Brown Long Trench Coat", ar: "Women Brown Long Trench Coat", fr: "Women Brown Long Trench Coat" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "Brown", fr: "Brown" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 35.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "411.png"), img("6", "411.2.png"), img("6", "411.3.png")],
  },
  {
    id: "412",
    name: { en: "Women Brown Long Trench Coat", ar: "Women Brown Long Trench Coat", fr: "Women Brown Long Trench Coat" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "Brown", fr: "Brown" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "412.png"), img("6", "412.2.png"), img("6", "412.3.png")],
  },
  {
    id: "413",
    name: { en: "5pcs Women Cotton Lace Panties Set", ar: "5pcs Women Cotton Lace Panties Set", fr: "5pcs Women Cotton Lace Panties Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 9.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "413.png"), img("6", "413.2.png"), img("6", "413.3.png")],
  },
  {
    id: "414",
    name: { en: "Velvet Jewelry Box Organizer", ar: "Velvet Jewelry Box Organizer", fr: "Velvet Jewelry Box Organizer" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Beige", ar: "Beige", fr: "Beige" },
    sizes: [{ label: "Standard", qty: 1 }],
    originalPrice: 6.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "414.png"), img("6", "414.2.png")],
  },
  {
    id: "415",
    name: { en: "Plus Coffee Brown Lantern Sleeve Curved Hem Shirt", ar: "Plus Coffee Brown Lantern Sleeve Curved Hem Shirt", fr: "Plus Coffee Brown Lantern Sleeve Curved Hem Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Coffee Brown", ar: "Coffee Brown", fr: "Coffee Brown" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 17.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "415.png"), img("6", "415.2.png"), img("6", "415.3.png")],
  },
  {
    id: "416",
    name: { en: "Women Baby Blue Pleated Hem Dress", ar: "Women Baby Blue Pleated Hem Dress", fr: "Women Baby Blue Pleated Hem Dress" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Baby Blue", ar: "Baby Blue", fr: "Baby Blue" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 20.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "416.png"), img("6", "416.2.png"), img("6", "416.3.png")],
  },
  {
    id: "417",
    name: { en: "Floral Print Asymmetrical Shoulder Top", ar: "Floral Print Asymmetrical Shoulder Top", fr: "Floral Print Asymmetrical Shoulder Top" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Floral", ar: "Floral", fr: "Floral" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "417.png"), img("6", "417.2.png"), img("6", "417.3.png")],
  },
  {
    id: "418",
    name: { en: "3pcs Toddler Cargo Pants", ar: "3pcs Toddler Cargo Pants", fr: "3pcs Toddler Cargo Pants" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "18–24M", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "418.png"), img("6", "418.2.png"), img("6", "418.3.png")],
  },
  {
    id: "419",
    name: { en: "Baby Boy Navy Blue Plaid Hooded Jacket & Pants Set", ar: "Baby Boy Navy Blue Plaid Hooded Jacket & Pants Set", fr: "Baby Boy Navy Blue Plaid Hooded Jacket & Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Navy Blue", ar: "Navy Blue", fr: "Navy Blue" },
    sizes: [{ label: "2–3Y", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("6", "419.png"), img("6", "419.2.png"), img("6", "419.3.png")],
  },
  {
    id: "420",
    name: { en: "Baby Girl Medium Wash Floral Embroidered Jeans", ar: "Baby Girl Medium Wash Floral Embroidered Jeans", fr: "Baby Girl Medium Wash Floral Embroidered Jeans" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Medium Wash", ar: "Medium Wash", fr: "Medium Wash" },
    sizes: [{ label: "9–12M", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "420.png"), img("7", "420.2.png"), img("7", "420.3.png")],
  },
  {
    id: "421",
    name: { en: "Girls Brown Furry Vest & Dress Set", ar: "Girls Brown Furry Vest & Dress Set", fr: "Girls Brown Furry Vest & Dress Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "Brown", fr: "Brown" },
    sizes: [{ label: "5Y", qty: 1 }],
    originalPrice: 16.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "421.png"), img("7", "421.2.png"), img("7", "421.3.png")],
  },
  {
    id: "422",
    name: { en: "Women Contrast Color Collar Fleece Jacket", ar: "Women Contrast Color Collar Fleece Jacket", fr: "Women Contrast Color Collar Fleece Jacket" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Beige", ar: "Beige", fr: "Beige" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 33.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "422.png"), img("7", "422.2.png"), img("7", "422.3.png")],
  },
  {
    id: "423",
    name: { en: "3pcs Baby Boy Color Block Pullover Sweatshirts Set", ar: "3pcs Baby Boy Color Block Pullover Sweatshirts Set", fr: "3pcs Baby Boy Color Block Pullover Sweatshirts Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "2–3Y", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "423.png"), img("7", "423.2.png"), img("7", "423.3.png")],
  },
  {
    id: "424",
    name: { en: "Men’s Grey Ribbed Sleeveless Polo", ar: "Men’s Grey Ribbed Sleeveless Polo", fr: "Men’s Grey Ribbed Sleeveless Polo" },
    category: "shein",
    sheinCategory: "men",
    authentic: false,
    discountPct: 30,
    color: { en: "Apricot", ar: "Apricot", fr: "Apricot" },
    sizes: [{ label: "XL", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "424.png"), img("7", "424.2.png"), img("7", "424.3.png")],
  },
  {
    id: "425",
    name: { en: "Women Brown Lace Trim Cami Top", ar: "Women Brown Lace Trim Cami Top", fr: "Women Brown Lace Trim Cami Top" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Brown", ar: "Brown", fr: "Brown" },
    sizes: [{ label: "S", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "425.png"), img("7", "425.2.png"), img("7", "425.3.png")],
  },
  {
    id: "426",
    name: { en: "Baby Girl Pink Floral Ruffle Collar Top & Pants Set", ar: "Baby Girl Pink Floral Ruffle Collar Top & Pants Set", fr: "Baby Girl Pink Floral Ruffle Collar Top & Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Pink", ar: "Pink", fr: "Pink" },
    sizes: [{ label: "9–12M", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "426.png"), img("7", "426.2.png"), img("7", "426.3.png")],
  },
  {
    id: "427",
    name: { en: "3pcs Soft Knit Cardigan, Sleeveless Top & Plaid Pajama Pants Set", ar: "3pcs Soft Knit Cardigan, Sleeveless Top & Plaid Pajama Pants Set", fr: "3pcs Soft Knit Cardigan, Sleeveless Top & Plaid Pajama Pants Set" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Cream / Red Plaid", ar: "Cream / Red Plaid", fr: "Cream / Red Plaid" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 24.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "427.png"), img("7", "427.2.png"), img("7", "427.3.png")],
  },
  {
    id: "428",
    name: { en: "Men’s Classic Black Plaid Comfortable Sporty Sneakers", ar: "Men’s Classic Black Plaid Comfortable Sporty Sneakers", fr: "Men’s Classic Black Plaid Comfortable Sporty Sneakers" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Black", ar: "Black", fr: "Black" },
    sizes: [{ label: "EUR 41", qty: 1 }],
    originalPrice: 22.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "428.png"), img("7", "428.2.png"), img("7", "428.3.png")],
  },
  {
    id: "429",
    name: { en: "Girls’ Plus Size Versatile White Sneakers, Colorful Butterfly Contrast Sports Shoes", ar: "Girls’ Plus Size Versatile White Sneakers, Colorful Butterfly Contrast Sports Shoes", fr: "Girls’ Plus Size Versatile White Sneakers, Colorful Butterfly Contrast Sports Shoes" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "white", ar: "white", fr: "white" },
    sizes: [{ label: "EUR 32", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "429.png"), img("7", "429.2.png"), img("7", "429.3.png")],
  },
  {
    id: "430",
    name: { en: "Tween Boys’ Casual Corduroy Patch Hooded Loose Woven Shirt", ar: "Tween Boys’ Casual Corduroy Patch Hooded Loose Woven Shirt", fr: "Tween Boys’ Casual Corduroy Patch Hooded Loose Woven Shirt" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Dark Green", ar: "Dark Green", fr: "Dark Green" },
    sizes: [{ label: "9Y", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "430.png"), img("7", "430.2.png"), img("7", "430.3.png")],
  },
  {
    id: "431",
    name: { en: "Flamini 1pc Women’s Red Plaid Embroidered Slim Fit Button-Down Long Sleeve Shirt", ar: "Flamini 1pc Women’s Red Plaid Embroidered Slim Fit Button-Down Long Sleeve Shirt", fr: "Flamini 1pc Women’s Red Plaid Embroidered Slim Fit Button-Down Long Sleeve Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Red", ar: "Red", fr: "Red" },
    sizes: [{ label: "M", qty: 1 }],
    originalPrice: 13.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "431.png"), img("7", "431.2.png"), img("7", "431.3.png")],
  },
  {
    id: "432",
    name: { en: "Girl’s New Style White Casual Sneakers With Lace & Pearl Embellishments", ar: "Girl’s New Style White Casual Sneakers With Lace & Pearl Embellishments", fr: "Girl’s New Style White Casual Sneakers With Lace & Pearl Embellishments" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    sizes: [{ label: "EUR 34", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "432.png"), img("7", "432.2.png"), img("7", "432.3.png")],
  },
  {
    id: "433",
    name: { en: "Mercer Haus Men’s Casual Hollow Out Design Shirt", ar: "Mercer Haus Men’s Casual Hollow Out Design Shirt", fr: "Mercer Haus Men’s Casual Hollow Out Design Shirt" },
    category: "shein",
    sheinCategory: "men",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    sizes: [{ label: "XL", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "433.png"), img("7", "433.2.png"), img("7", "433.3.png")],
  },
  {
    id: "434",
    name: { en: "Women Black/Grey Denim Jeans", ar: "Women Black/Grey Denim Jeans", fr: "Women Black/Grey Denim Jeans" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Grey / Black Wash", ar: "Grey / Black Wash", fr: "Grey / Black Wash" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 15.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "434.png"), img("7", "434.2.png"), img("7", "434.3.png")],
  },
  {
    id: "435",
    name: { en: "Red Satin Cami Pajama Dress / Night Dress", ar: "Red Satin Cami Pajama Dress / Night Dress", fr: "Red Satin Cami Pajama Dress / Night Dress" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Red", ar: "Red", fr: "Red" },
    sizes: [{ label: "1XL", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "435.png"), img("7", "435.2.png"), img("7", "435.3.png")],
  },
  {
    id: "436",
    name: { en: "Kids Strawberry Sneakers / Casual Shoes", ar: "Kids Strawberry Sneakers / Casual Shoes", fr: "Kids Strawberry Sneakers / Casual Shoes" },
    category: "shein",
    sheinCategory: "shoes",
    authentic: false,
    discountPct: 30,
    color: { en: "Red", ar: "Red", fr: "Red" },
    sizes: [{ label: "EUR32", qty: 1 }],
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "436.png"), img("7", "436.2.png"), img("7", "436.3.png")],
  },
  {
    id: "437",
    name: { en: "Kids Ankle Socks – 5 Pairs / Heart Design", ar: "Kids Ankle Socks – 5 Pairs / Heart Design", fr: "Kids Ankle Socks – 5 Pairs / Heart Design" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    sizes: [{ label: "3–8 years", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "437.png"), img("7", "437.2.png"), img("7", "437.3.png")],
  },
  {
    id: "438",
    name: { en: "Women White Button Up Shirt", ar: "Women White Button Up Shirt", fr: "Women White Button Up Shirt" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "438.png"), img("7", "438.2.png"), img("7", "438.3.png")],
  },
  {
    id: "439",
    name: { en: "Baby Girls Sweet Bow Sweatshirt & Pink Pants Set", ar: "Baby Girls Sweet Bow Sweatshirt & Pink Pants Set", fr: "Baby Girls Sweet Bow Sweatshirt & Pink Pants Set" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "White / Pink", ar: "White / Pink", fr: "White / Pink" },
    sizes: [{ label: "18–24M", qty: 1 }],
    originalPrice: 14.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "439.png"), img("7", "439.2.png"), img("7", "439.3.png")],
  },
  {
    id: "440",
    name: { en: "Casual Grey/Black Top", ar: "Casual Grey/Black Top", fr: "Casual Grey/Black Top" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "black & grey", ar: "black & grey", fr: "black & grey" },
    sizes: [{ label: "15y", qty: 1 }],
    originalPrice: 7.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "440.png"), img("7", "440.2.png"), img("7", "440.3.png")],
  },
  {
    id: "441",
    name: { en: "2-in-1 Facial Hair Remover & Eyebrow Trimmer", ar: "2-in-1 Facial Hair Remover & Eyebrow Trimmer", fr: "2-in-1 Facial Hair Remover & Eyebrow Trimmer" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    quantity: 1,
    originalPrice: 12.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "441.png")],
  },
  {
    id: "442",
    name: { en: "2pcs Kojic Acid Soap Papaya Handmade Essential Oil Soap", ar: "2pcs Kojic Acid Soap Papaya Handmade Essential Oil Soap", fr: "2pcs Kojic Acid Soap Papaya Handmade Essential Oil Soap" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 4.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "442.png")],
  },
  {
    id: "443",
    name: { en: "5pcs/Set Flower & Butterfly Necklace, Bracelet, Ring, Earrings Jewelry Set", ar: "5pcs/Set Flower & Butterfly Necklace, Bracelet, Ring, Earrings Jewelry Set", fr: "5pcs/Set Flower & Butterfly Necklace, Bracelet, Ring, Earrings Jewelry Set" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "Light Blue", ar: "Light Blue", fr: "Light Blue" },
    quantity: 1,
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "443.png")],
  },
  {
    id: "444",
    name: { en: "Women’s Solid Color Middle Eastern Classic Fashion Head Scarf", ar: "Women’s Solid Color Middle Eastern Classic Fashion Head Scarf", fr: "Women’s Solid Color Middle Eastern Classic Fashion Head Scarf" },
    category: "shein",
    sheinCategory: "accessories",
    authentic: false,
    discountPct: 30,
    color: { en: "light brown", ar: "light brown", fr: "light brown" },
    quantity: 1,
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "444.png"), img("7", "444.2.png"), img("7", "444.3.png")],
  },
  {
    id: "445",
    name: { en: "Press-on Nails – 24 pcs", ar: "Press-on Nails – 24 pcs", fr: "Press-on Nails – 24 pcs" },
    category: "shein",
    sheinCategory: "beauty",
    authentic: false,
    discountPct: 30,
    color: { en: "Wine red", ar: "Wine red", fr: "Wine red" },
    sizes: [{ label: "L", qty: 1 }],
    originalPrice: 2.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "445.png")],
  },
  {
    id: "446",
    name: { en: "Soap Holder", ar: "Soap Holder", fr: "Soap Holder" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    color: { en: "Grey", ar: "Grey", fr: "Grey" },
    quantity: 1,
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "446.png"), img("7", "446.2.png")],
  },
  {
    id: "447",
    name: { en: "2-in-1 Stylus Pen for Smartphones/Tablets", ar: "2-in-1 Stylus Pen for Smartphones/Tablets", fr: "2-in-1 Stylus Pen for Smartphones/Tablets" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    quantity: 1,
    originalPrice: 3.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "447.png"), img("7", "447.2.png"), img("7", "447.3.png")],
  },
  {
    id: "448",
    name: { en: "10 Pairs Kids Bear Pattern Ankle Socks", ar: "10 Pairs Kids Bear Pattern Ankle Socks", fr: "10 Pairs Kids Bear Pattern Ankle Socks" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "Multicolor", ar: "Multicolor", fr: "Multicolor" },
    sizes: [{ label: "0–1Y", qty: 1 }],
    originalPrice: 5.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "448.png"), img("7", "448.2.png")],
  },
  {
    id: "449",
    name: { en: "5 Pairs Baby Cute Bear Design Socks", ar: "5 Pairs Baby Cute Bear Design Socks", fr: "5 Pairs Baby Cute Bear Design Socks" },
    category: "shein",
    sheinCategory: "kids",
    authentic: false,
    discountPct: 30,
    color: { en: "White", ar: "White", fr: "White" },
    sizes: [{ label: "6–12M", qty: 1 }],
    originalPrice: 3.5,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "449.png"), img("7", "449.2.png"), img("7", "449.3.png"), img("7", "449.4.png"), img("7", "449.5.png"), img("7", "449.6.png"), img("7", "449.7.png")],
  },
  {
    id: "450",
    name: { en: "2D Rotating Anatomical Brain Model", ar: "2D Rotating Anatomical Brain Model", fr: "2D Rotating Anatomical Brain Model" },
    category: "shein",
    sheinCategory: "women",
    authentic: false,
    discountPct: 30,
    sizes: [{ label: "4 inch / 10 cm height", qty: 1 }],
    originalPrice: 2.0,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: [img("7", "450.png"), img("7", "450.2.png"), img("7", "450.3.png")],
  },
];
